<template>
  <div class="DataTable">
    <div class="vld-parent">
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        :is-full-page="fullPage"
        color="#018389"
        loader="dots"
      ></loading>
    </div>
    <v-form ref="form" v-model="valid" lazy-validation>
      <div style="border-style: groove; border-width: 1px">
        <v-layout row wrap>
          <v-flex xs12 pa-2>
            <span v-if="this.kolicinaVina > 0"
              >Faza {{ this.faza_mark }} / Količina {{ this.kolicinaVina }}
              {{ this.jm_mark }}</span
            >
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs6 pa-2>
            <v-autocomplete
              v-model="tank_to_select"
              :items="tank_to_items"
              item-value="id"
              item-text="name"
              :rules="[(v) => !!v || 'Obavezan podatak']"
              label="Tank u koji se pretače"
              required
              persistent-hint
              return-object
              v-on:change="changeRoute"
              :disabled="disabled_tank"
            >
              <template slot="selection" slot-scope="data">
                <template v-if="data.item.phaseMark === null"
                  >{{ data.item.name }} / (prazan tank) / Zapremina
                  {{ data.item.capacity }}
                  {{ data.item.unitOfMeasureMark }}</template
                >
                <template v-else-if="data.item.id === undefined"
                  >Izaberite tank</template
                >
                <template v-else-if="!edit"
                  >{{ data.item.name }} / {{ data.item.phaseMark }}</template
                >
                <template v-else
                  >{{ data.item.name }} / {{ data.item.phaseMark }} / Slobodno
                  {{ data.item.capacity - data.item.currentQuantity }}
                  {{ data.item.unitOfMeasureMark }}</template
                >
              </template>
              <template slot="item" slot-scope="data">
                <template v-if="data.item.phaseMark === null"
                  >{{ data.item.name }} / (prazan tank) / Zapremina
                  {{ data.item.capacity }}
                  {{ data.item.unitOfMeasureMark }}</template
                >
                <template v-else-if="data.item.id === undefined"
                  >Izaberite tank</template
                >
                <template v-else-if="!edit"
                  >{{ data.item.name }} / {{ data.item.phaseMark }}</template
                >
                <template v-else
                  >{{ data.item.name }} / {{ data.item.phaseMark }} / Slobodno
                  {{ data.item.capacity - data.item.currentQuantity }}
                  {{ data.item.unitOfMeasureMark }}</template
                >
              </template>
            </v-autocomplete>
          </v-flex>
          <v-flex xs5 pa-2>
            <v-select
              v-model="phase_to_select"
              :items="phase_to_items_pom"
              item-text="name"
              item-value="id"
              label="Faza tanka u koji se pretače"
              persistent-hint
              return-object
              :disabled="!edit"
            >
              <template slot="selection" slot-scope="data">
                <template v-if="data.item.id === undefined"
                  >Izaberite fazu</template
                >
                <template v-else>{{ data.item.name }}</template>
              </template>
              <template slot="item" slot-scope="data">
                <template v-if="data.item.id === undefined"
                  >Izaberite fazu</template
                >
                <template v-else>{{ data.item.name }}</template>
              </template>
            </v-select>
          </v-flex>
          <v-flex xs4 pa-2 v-if="1 === 2">
            <v-select
              v-model="wine_to_select"
              :items="wine_to_items"
              item-value="id"
              label="Vino"
              persistent-hint
              return-object
              :disabled="disabled_vine"
            >
              <template slot="selection" slot-scope="data"
                >{{ data.item.year }} - {{ data.item.wineLabel.name }}</template
              >
              <template slot="item" slot-scope="data"
                >{{ data.item.year }} - {{ data.item.wineLabel.name }}</template
              >
            </v-select>
          </v-flex>
        </v-layout>
        <v-layout v-if="tank_type === 'batch'">
          <v-flex xs12 pa-2>
            <v-autocomplete
              ref="elementsarza"
              v-model="sarza_select"
              :items="sarza_items"
              :item-text="getFieldText"
              item-value="tank.id"
              label="Barik"
              multiple
              chips
              deletable-chips
              hide-no-data
              clearable
              persistent-hint
              return-object
              
              :disabled="!edit"
            ></v-autocomplete>
          </v-flex>
          <!-- v-on:change="changeSarza" -->
        </v-layout>
      </div>
    </v-form>
    <v-form ref="form_nemavalidacije" v-model="valid" lazy-validation>
      <v-layout row wrap>
        <v-flex xs2 pa-2>
          <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            max-width="290px"
            min-width="290px"
            :disabled="!edit"
          >
            <v-text-field
              slot="activator"
              v-model="dateFormatted"
              label="Datum"
              readonly
              :rules="[(v) => !!v || 'Obavezan podatak']"
              required
              @blur="date = parseDate(dateFormatted)"
              :disabled="!edit"
            ></v-text-field>
            <v-date-picker
              v-model="date"
              no-title
              @input="menu = false"
              :max="maxDate"
            ></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex xs2 pa-2>
          <v-menu
            ref="menu1"
            :close-on-content-click="false"
            v-model="menu1"
            :nudge-right="0"
            :return-value.sync="time"
            transition="scale-transition"
            lazy
            offset-y
            full-width
            min-width="290px"
            @input="
              (value) =>
                value && $refs.picker && ($refs.picker.selectingHour = true)
            "
            :disabled="!edit"
          >
            <v-text-field
              slot="activator"
              v-model="time"
              label="Vreme"
              readonly
              :rules="[(v) => !!v || 'Obavezan podatak']"
              required
              :disabled="!edit"
            ></v-text-field>
            <v-time-picker
              v-model="time"
              ref="picker"
              full-width
              landscape
              class="mt-3"
              format="24hr"
              :allowed-minutes="allowedStep"
              v-on:change="$refs.menu1.save(time)"
            >
              <v-spacer></v-spacer>
              <v-btn flat color="primary" @click="menu1 = false">Cancel</v-btn>
              <!-- <v-btn flat color="primary" @click="$refs.menu1.save(time)">OK</v-btn> -->
            </v-time-picker>
          </v-menu>
        </v-flex>
        <v-flex xs5 pa-2> </v-flex>
        <v-flex xs3 pa-2>
          <v-text-field
            v-model="pressing_fraction"
            label="Frakcija"
            ref="element2"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <!-- /.Name -->
    </v-form>

    <v-layout row wrap>
      <v-flex xs2 pa-2>
        <v-text-field
          v-model="wine_quantity"
          label="Količina"
          type="number"
          :rules="[(v) => !!v || 'Obavezan podatak']"
          required
          :disabled="!edit"
          ref="element5"
        ></v-text-field>
      </v-flex>

      <v-flex xs1 pa-2>
        <v-select
          v-model="jm_dolivanja_select"
          :items="jm_items"
          item-text="mark"
          item-value="id"
          :rules="[(v) => !!v || 'Obavezan podatak']"
          label="JM"
          required
          persistent-hint
          return-object
          :disabled="!edit"
        ></v-select>
      </v-flex>
      <v-flex xs2 pa-2>
        <v-text-field
          v-model="sediment_quantity"
          :label="tekst_labele_1"
          type="number"
          :disabled="!edit"
          v-on:change="onKominaChange"
          ref="element6"
        ></v-text-field>
      </v-flex>

      <v-flex xs1 pa-2>
        <v-select
          v-model="jm_sediment_select"
          :items="jm_sediment_items"
          item-text="mark"
          item-value="id"
          label="JM"
          persistent-hint
          return-object
          disabled
        ></v-select>
      </v-flex>
      <v-flex xs2 pa-2>
        <v-text-field
          v-model="outage_quantity"
          label="Rastur"
          type="number"
          :disabled="!edit"
          ref="element7"
        ></v-text-field>
      </v-flex>

      <v-flex xs1 pa-2>
        <v-select
          v-model="jm_outage_select"
          :items="jm_outage_items"
          item-text="mark"
          item-value="id"
          label="JM"
          persistent-hint
          return-object
          :disabled="!edit"
        ></v-select>
      </v-flex>
      <v-flex xs3 pa-2>
        <v-checkbox
          :label="tekst_labele_2"
          ref="element1"
          v-model="cvalue"
          @change="onCheckboxChange"
          :disabled="!edit"
        ></v-checkbox>
      </v-flex>
      <!-- :disabled="izmena_praznjenja" -->
    </v-layout>
    <!-- /.Name -->
    <v-form ref="form1" v-model="valid" lazy-validation>
      <v-layout row wrap>
        <v-flex xs12 pa-2>
          <v-textarea
            v-model="opis"
            name="input-5-1"
            class="Description"
            label="Opis"
          ></v-textarea>
        </v-flex>
      </v-layout>
      <!-- /.Tank -->

      <v-layout row wrap>
        <v-flex xs12>
          <v-btn
            :disabled="!valid"
            @click="submit"
            class="AppButtonFilled"
            >Sačuvaj</v-btn
          >
          <v-btn
            @click="clear"
            class="AppButtonOutlined"
            >odustani</v-btn
          >
        </v-flex>
      </v-layout>
      <!-- /.Action buttons -->
    </v-form>
    <TokenComponent ref="frmtoken" />
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

import { serverBus } from "../main";
import { readJSON } from "../helpers/Functions";
import TokenComponent from "../components/Token";

export default {
  name: "DecantingItem",
  components: {
    TokenComponent,
    Loading,
  },
  data: () => ({
    isLoading: false,
    loading: true,
    fullPage: true,

    valid: true,
    ID: "0",
    opis: "",
    tank_to_items: [],
    tank_to_items_init: [],
    tank_to_select: "",
    tank_to_select_name_stara: "",
    tank_to_select_name_nova: "",
    phase_to_items: [],
    wine_to_items: [],
    phase_to_select: "",
    wine_to_select: "",
    vineyard_grape_variety_items: [],
    jm_dolivanja_select: "",
    jm_outage_select: "",
    jm_sediment_select: {
      id: 1111,
      mark: "kg",
    },
    vineyard_grape_variety_select: "",
    date: null, //For datepicker
    menu: "",
    // entry_date: null, //For datepicker
    // entry_menu: "",
    wine_quantity: 0,
    jm_items: [],
    outage_quantity: undefined,
    jm_outage_items: [],
    sediment_quantity: undefined,
    jm_sediment_items: [
      {
        id: 1111,
        mark: "kg",
      },
    ],
    id_tank_phase_wine: 0,
    id_tank: 0,
    id_tank_phase_wine_blend: 0,
    kolicinaVina: 0,
    kolicinaVinaPom: 0,
    preostalo_izabrani_tank: 0,
    preostalo_izabrani_tank_jm: "",
    faza_izabrani_tank: 0,
    faza: -1,
    tekst_labele_1: "",
    tekst_labele_2: "Ispražnjena presa",
    tip_vina_izabrani_tank: 0,
    tip_vina_izabrani_tank_naziv: "",
    phase_to_items_pom: [],
    tipVina: 0,
    tip_vina_izabrani_tank_pom: null,
    tip_vina_tank: 0,
    cvalue: false,
    disabled_vine: false,
    disabled_tank: false,
    isEmptyTank: false,
    time: undefined,
    menu1: "",
    id_jedinica_mere: 0,
    faza_mark: "",
    jm_mark: "",
    prethodna_faza: 0,
    datetime_action: "",
    faza_izabranog_tanka: 0,

    date: null,
    dateFormatted: null,
    edit: true,
    tank_type: "",
    sarza: false,
    sarza_items: [],
    sarza_select: [],
    izabrani_barici: [],
    kolicina_vina_barici: 0,
    applied: false,
    pressing_fraction: undefined,
    datum_praznjenja_prese: null,
    izmena_praznjenja: true,

    litar: undefined,
  }),
  watch: {
    date(val) {
      this.dateFormatted = this.formatDate1(this.date);
    },
  },
  computed: {
    maxDate() {
      const today = new Date();
      // const dd = today.getUTCDate();
      return this.formatDate(today);
    },
  },
  methods: {
    getAllSarze(id_sarze, item) {
      let url;

      if (this.id_tank_phase_wine !== 0)
        url =
          this.globalServiceLocation +
          this.globalPort +
          "/tank/tanks_in_batch/" +
          id_sarze +
          "/modal?tpwId=" +
          this.id_tank_phase_wine;
      else
        url =
          this.globalServiceLocation +
          this.globalPort +
          "/tank/tanks_in_batch/" +
          id_sarze +
          "/modal";

      this.$http
        .get(url, {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer  " + localStorage.getItem("user-token"),
          },
        })
        .then((response) => {
          // console.log(response.data);
          this.sarza_items = response.data;

          let objPom = [];

          if (this.ID !== 0 && item !== null) {
            item.tankFromBatchInOperations.forEach(function (entry) {
              objPom.push(entry);
            });

            this.sarza_select = objPom;
            this.izabrani_barici = objPom;
          }
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(url, {
                      headers: {
                        "Content-Type": "application/json",
                        Authorization:
                          "Bearer  " + localStorage.getItem("user-token"),
                      },
                    })
                    .then((response) => {
                      this.sarza_items = response.data;

                      let objPom = [];

                      if (this.ID !== 0 && item !== null) {
                        item.tankFromBatchInOperations.forEach(function (
                          entry
                        ) {
                          objPom.push(entry);
                        });

                        this.sarza_select = objPom;
                      }
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    getFieldText(item) {
      let tekst = "";

      if (item.id !== undefined) {
        if (
          item.batchPrefix !== null &&
          item.tankNumberInBatch !== null &&
          item.batchPrefix !== "" &&
          item.tankNumberInBatch !== ""
        )
          if (
            item.tank.inventoryNumber !== null &&
            item.tank.inventoryNumber !== undefined
          )
            tekst = `${item.batchPrefix} - ${item.tankNumberInBatch} | ${item.tank.name} | ${item.tank.inventoryNumber}`;
          else
            tekst = `${item.batchPrefix} - ${item.tankNumberInBatch} | ${item.tank.name})`;
        else if (
          (item.batchPrefix === null || item.batchPrefix === "") &&
          (item.tankNumberInBatch === null || item.tankNumberInBatch === "")
        )
          if (
            item.tank.inventoryNumber !== null &&
            item.tank.inventoryNumber !== undefined
          )
            tekst = `${item.tank.name} | ${item.tank.inventoryNumber}`;
          else tekst = `${item.tank.name}`;
        else if (
          item.tankNumberInBatch === null ||
          item.tankNumberInBatch === ""
        )
          if (
            item.tank.inventoryNumber !== null &&
            item.tank.inventoryNumber !== undefined
          )
            tekst = `${item.batchPrefix} | ${item.tank.name} | ${item.tank.inventoryNumber}`;
          else tekst = `${item.batchPrefix} (${item.tank.name})`;
        else if (item.batchPrefix === null || item.batchPrefix === "")
          if (
            item.tank.inventoryNumber !== null &&
            item.tank.inventoryNumber !== undefined
          )
            tekst = `${item.tankNumberInBatch} | ${item.tank.name} | ${item.tank.inventoryNumber}`;
          else tekst = `${item.tankNumberInBatch} | ${item.tank.name}`;
      }

      return tekst;
    },
    formatDate1(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}.${month}.${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split(".");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    allowedStep: (m) => m % 5 === 0,
    formatDate(date) {
      let month = `${date.getMonth() + 1}`;
      let day = `${date.getDate()}`;
      const year = date.getFullYear();

      if (month.length < 2) month = `0${month}`;
      if (day.length < 2) day = `0${day}`;

      return [year, month, day].join("-");
    },
    setTime() {
      const today = new Date();
      let Minutes = `${today.getMinutes()}`;
      let Hours = `${today.getHours()}`;

      if (Hours.length < 2) Hours = `0${Hours}`;
      if (Minutes.length < 2) Minutes = `0${Minutes}`;

      this.time = [Hours, Minutes].join(":");
    },
    setDate() {
      const today = new Date();
      let Year = `${today.getFullYear()}`;
      let Month = `${today.getMonth() + 1}`;
      let Day = `${today.getDate()}`;

      if (Month.length < 2) Month = `0${Month}`;
      if (Day.length < 2) Day = `0${Day}`;

      this.date = [Year, Month, Day].join("-");
    },
    formatTime(time) {
      let HH = time.split(":")[0];
      let mm = time.split(":")[1];

      return HH + ":" + mm;
    },
    newSifarnik() {
      if (this.tank_to_select !== undefined) {
        if (
          this.sediment_quantity !== null &&
          this.sediment_quantity !== undefined &&
          this.sediment_quantity !== ""
        )
          this.cvalue = true;
        else this.cvalue = false;

        let w_q = 0;
        if (this.wine_quantity !== undefined && this.wine_quantity !== null)
          w_q = Number(
            this.jm_dolivanja_select.mark === "l"
              ? this.wine_quantity
              : this.wine_quantity * 100
          );

        let s_q = 0;
        if (
          this.sediment_quantity !== undefined &&
          this.sediment_quantity !== null
        )
          s_q = Number(
            this.jm_sediment_select.mark === "l"
              ? this.sediment_quantity
              : this.sediment_quantity * 100
          );

        let o_q = 0;
        if (this.outage_quantity !== undefined && this.outage_quantity !== null)
          o_q = Number(
            this.jm_outage_select.mark === "l"
              ? this.outage_quantity
              : this.outage_quantity * 100
          );

        // if (
        //   this.tank_type === "batch" &&
        //   this.kolicina_vina_barici !== w_q + s_q + o_q &&
        //   this.sarza_select.length > 0
        // ) {
        //   this.isLoading = false;
        //   alert(
        //     "Zapremina izabranih barika je različita od ukupne količine vina, taloga i rastura."
        //   );
        // } else {
          let kolicinaVina = Number(this.kolicinaVina);
          let wine_quantity = Number(this.wine_quantity);

          var complexObjectSarza = [];

          if (this.tank_type === "batch") {
            let objekat;

            if (this.sarza_select !== undefined) {
              this.sarza_select.forEach(function (entry) {
                if (entry.tank.id !== undefined)
                  objekat = {
                    tank: {
                      id: entry.tank.id,
                    },
                  };
                else
                  objekat = {
                    tank: {
                      id: entry,
                    },
                  };
                complexObjectSarza.push(objekat);
              });
            }
          }
          var pom_phase_to_select;

          if (typeof this.phase_to_select !== "undefined")
            if (typeof this.phase_to_select.id !== "undefined")
              if (this.phase_to_select.id == null)
                pom_phase_to_select = this.phase_to_select;
              else pom_phase_to_select = this.phase_to_select.id;

          var pom_jm_dolivanja_select;
          if (this.jm_dolivanja_select === null) pom_jm_dolivanja_select = "0";
          if (typeof this.jm_dolivanja_select === "undefined")
            pom_jm_dolivanja_select = "0";
          else if (this.jm_dolivanja_select.id == null)
            pom_jm_dolivanja_select = this.jm_dolivanja_select;
          else pom_jm_dolivanja_select = this.jm_dolivanja_select.id;

          var pom_jm_outage_select;

          if (this.jm_outage_select === null) pom_jm_outage_select = "0";
          else if (typeof this.jm_outage_select === "undefined")
            pom_jm_outage_select = "0";
          else if (this.jm_outage_select.id == null)
            pom_jm_outage_select = this.jm_outage_select;
          else pom_jm_outage_select = this.jm_outage_select.id;

          // if (this.tip_vina_izabrani_tank_pom !== null && typeof this.tip_vina_izabrani_tank_pom !== "undefined" && this.tip_vina_izabrani_tank_pom !== this.tip_vina_tank)
          // 	alert('U izabranim tankovima se ne nalazi isto vino.');
          // else

          if (Number(wine_quantity) === 0) {
            this.isLoading = false;
            alert("Uneta količina ne sme imati vrednost nula.");
          } else if (this.isEmptyTank) {
            this.isLoading = false;
            alert("Izabrani tank je prazan");
          } else if (
            typeof this.wine_to_select === "undefined" &&
            this.tip_vina_izabrani_tank_pom !== this.tip_vina_tank &&
            this.tip_vina_izabrani_tank_pom !== null &&
            typeof this.tip_vina_izabrani_tank_pom !== "undefined"
          ) {
            this.isLoading = false;
            alert(
              "U tankovima se ne nalazi isto vino, morate navesti novo vino"
            );
          }
          // else if (
          //   Number(this.faza_izabrani_tank) !== Number(this.faza) &&
          //   typeof pom_phase_to_select === "undefined" &&
          //   this.faza_izabrani_tank !== null
          // )
          //   alert(
          //     "Presovanje nije moguće, izabrani tankovi se ne nalaze u istoj fazi"
          //   );
          else if (
            Number(this.tipVina) !== Number(this.tip_vina_izabrani_tank) &&
            this.tip_vina_izabrani_tank !== 0
          ) {
            this.isLoading = false;
            alert(
              "Presovanje nije moguće, u izabranom tanku se nalazi " +
                this.tip_vina_izabrani_tank_naziv +
                " vino."
            );
          } else if (this.id_tank == this.tank_to_select.id) {
            this.isLoading = false;
            alert("Izabrite drugi tank");
          }
          // else if (wine_quantity + outage_quantity > preostalo_izabrani_tank)
          //   alert(
          //     "U izabranom tanku preostalo je " +
          //       this.preostalo_izabrani_tank + " " + this.preostalo_izabrani_tank_jm +
          //       " slobodne zapremine."
          //   );
          else if (
            Number(this.sediment_quantity) === 0 ||
            typeof this.sediment_quantity === "undefined" ||
            typeof this.sediment_quantity === ""
          ) {
            var complexObject;

            if (
              Number(this.outage_quantity) === 0 ||
              this.outage_quantity === "" ||
              this.outage_quantity === undefined
            ) {
              if (
                typeof this.wine_to_select !== "undefined" &&
                this.tip_vina_izabrani_tank_pom !== null &&
                typeof this.tip_vina_izabrani_tank_pom !== "undefined" &&
                this.tip_vina_izabrani_tank_pom !== this.tip_vina_tank
              )
                if (
                  // this.faza_izabrani_tank !== null &&
                  // typeof this.faza_izabrani_tank !== "undefined" &&
                  typeof pom_phase_to_select !== "undefined"
                )
                  complexObject = {
                    tankPhaseWineId: this.id_tank_phase_wine,
                    toTankId: this.tank_to_select.id,
                    toPhaseId: pom_phase_to_select,
                    toWineId: this.wine_to_select.id,
                    decantingDate: this.date + "T" + this.time,
                    quantity: Number(this.wine_quantity),
                    // sediment: 0,
                    // outage: 0,
                    quantityUnitOfMeasureId: pom_jm_dolivanja_select,
                    // sedimentUnitOfMeasureId: null,
                    // outageUnitOfMeasureId: null,
                    description: this.opis,
                    tankFromBatchInOperations: complexObjectSarza,
                  };
                else
                  complexObject = {
                    tankPhaseWineId: this.id_tank_phase_wine,
                    toTankId: this.tank_to_select.id,
                    //toPhaseId: this.phase_to_select.id,
                    toWineId: this.wine_to_select.id,
                    decantingDate: this.date + "T" + this.time,
                    quantity: Number(this.wine_quantity),
                    // sediment: 0,
                    // outage: 0,
                    quantityUnitOfMeasureId: pom_jm_dolivanja_select,
                    // sedimentUnitOfMeasureId: null,
                    // outageUnitOfMeasureId: null,
                    description: this.opis,
                    tankFromBatchInOperations: complexObjectSarza,
                  };
              else if (
                // this.faza_izabrani_tank !== null &&
                // typeof this.faza_izabrani_tank !== "undefined" &&
                typeof pom_phase_to_select !== "undefined"
              )
                complexObject = {
                  tankPhaseWineId: this.id_tank_phase_wine,
                  toTankId: this.tank_to_select.id,
                  toPhaseId: pom_phase_to_select,
                  // toWineId: this.wine_to_select.id,
                  decantingDate: this.date + "T" + this.time,
                  quantity: Number(this.wine_quantity),
                  // sediment: 0,
                  // outage: 0,
                  quantityUnitOfMeasureId: pom_jm_dolivanja_select,
                  // sedimentUnitOfMeasureId: null,
                  // outageUnitOfMeasureId: null,
                  description: this.opis,
                  tankFromBatchInOperations: complexObjectSarza,
                };
              else
                complexObject = {
                  tankPhaseWineId: this.id_tank_phase_wine,
                  toTankId: this.tank_to_select.id,
                  //toPhaseId: this.phase_to_select.id,
                  // toWineId: this.wine_to_select.id,
                  decantingDate: this.date + "T" + this.time,
                  quantity: Number(this.wine_quantity),
                  // sediment: 0,
                  // outage: 0,
                  quantityUnitOfMeasureId: pom_jm_dolivanja_select,
                  // sedimentUnitOfMeasureId: null,
                  // outageUnitOfMeasureId: null,
                  description: this.opis,
                  tankFromBatchInOperations: complexObjectSarza,
                };
            } else if (
              typeof this.wine_to_select !== "undefined" &&
              this.tip_vina_izabrani_tank_pom !== null &&
              typeof this.tip_vina_izabrani_tank_pom !== "undefined" &&
              this.tip_vina_izabrani_tank_pom !== this.tip_vina_tank
            )
              if (
                // this.faza_izabrani_tank !== null &&
                // typeof this.faza_izabrani_tank !== "undefined" &&
                typeof pom_phase_to_select !== "undefined"
              )
                complexObject = {
                  tankPhaseWineId: this.id_tank_phase_wine,
                  toTankId: this.tank_to_select.id,
                  toPhaseId: pom_phase_to_select,
                  toWineId: this.wine_to_select.id,
                  decantingDate: this.date + "T" + this.time,
                  quantity: Number(this.wine_quantity),
                  // sediment: 0,
                  outage: this.outage_quantity,
                  quantityUnitOfMeasureId: pom_jm_dolivanja_select,
                  // sedimentUnitOfMeasureId: null,
                  outageUnitOfMeasureId: pom_jm_outage_select,
                  description: this.opis,
                  tankFromBatchInOperations: complexObjectSarza,
                };
              else
                complexObject = {
                  tankPhaseWineId: this.id_tank_phase_wine,
                  toTankId: this.tank_to_select.id,
                  //toPhaseId: this.phase_to_select.id,
                  toWineId: this.wine_to_select.id,
                  decantingDate: this.date + "T" + this.time,
                  quantity: Number(this.wine_quantity),
                  // sediment: 0,
                  outage: this.outage_quantity,
                  quantityUnitOfMeasureId: pom_jm_dolivanja_select,
                  // sedimentUnitOfMeasureId: null,
                  outageUnitOfMeasureId: pom_jm_outage_select,
                  description: this.opis,
                  tankFromBatchInOperations: complexObjectSarza,
                };
            else if (
              // this.faza_izabrani_tank !== null &&
              // typeof this.faza_izabrani_tank !== "undefined" &&
              typeof pom_phase_to_select !== "undefined"
            )
              complexObject = {
                tankPhaseWineId: this.id_tank_phase_wine,
                toTankId: this.tank_to_select.id,
                toPhaseId: pom_phase_to_select,
                // toWineId: this.wine_to_select.id,
                decantingDate: this.date + "T" + this.time,
                quantity: Number(this.wine_quantity),
                // sediment: 0,
                outage: this.outage_quantity,
                quantityUnitOfMeasureId: pom_jm_dolivanja_select,
                // sedimentUnitOfMeasureId: null,
                outageUnitOfMeasureId: pom_jm_outage_select,
                description: this.opis,
                tankFromBatchInOperations: complexObjectSarza,
              };
            else
              complexObject = {
                tankPhaseWineId: this.id_tank_phase_wine,
                toTankId: this.tank_to_select.id,
                //toPhaseId: this.phase_to_select.id,
                // toWineId: this.wine_to_select.id,
                decantingDate: this.date + "T" + this.time,
                quantity: Number(this.wine_quantity),
                // sediment: 0,
                outage: this.outage_quantity,
                quantityUnitOfMeasureId: pom_jm_dolivanja_select,
                // sedimentUnitOfMeasureId: null,
                outageUnitOfMeasureId: pom_jm_outage_select,
                description: this.opis,
                tankFromBatchInOperations: complexObjectSarza,
              };

            complexObject.pressing = true;
            complexObject.pressingFraction = this.pressing_fraction;
            complexObject.emptiedPress = this.cvalue;

            this.$http
              .post(
                this.globalServiceLocation +
                  this.globalPort +
                  "/tank_phase_wine/decanting",
                complexObject,
                {
                  headers: {
                    "Content-Type": "application/json",
                    Authorization:
                      "Bearer  " + localStorage.getItem("user-token"),
                  },
                }
              )
              .then((response) => {
                this.isLoading = false;

                if (response.data.isEmptyTank) {
                  //this.id_tank_phase_wine = 0;
                  this.kolicinaVina = 0;
                  this.isEmptyTank = true;
                } else {
                  if (this.phase_to_select.id !== undefined)
                    this.faza_izabrani_tank = this.phase_to_select.id;
                  else this.faza_izabrani_tank = this.phase_to_select;

                  this.getAllTankovi();

                  let s_q = 0;
                  if (this.sediment_quantity !== undefined)
                    s_q = Number(this.sediment_quantity);

                  let o_q = 0;
                  if (this.outage_quantity !== undefined)
                    o_q = Number(this.outage_quantity);

                  this.kolicinaVina =
                    Number(this.kolicinaVinaPom) -
                    Number(this.wine_quantity) -
                    s_q -
                    o_q;
                }

                serverBus.$emit("refresh_pressing", this.id_tank_phase_wine);

                this.clear();
              })
              .catch((e) => {
                // // console.log(e.response);

                if (!e.response) {
                  this.isLoading = false;

                  alert(
                    this.$t("error.message")
                  );
                } else {
                  if (e.response.status === 401) {
                    this.$refs.frmtoken
                      .osvezavanjeTokena(
                        localStorage.getItem("user-refresh-token")
                      )
                      .then((result) => {
                        // // console.log(result);
                        // // console.log("Novi token - " + localStorage.getItem("user-token"));

                        this.$http
                          .post(
                            this.globalServiceLocation +
                              this.globalPort +
                              "/tank_phase_wine/decanting",
                            complexObject,
                            {
                              headers: {
                                "Content-Type": "application/json",
                                Authorization:
                                  "Bearer  " +
                                  localStorage.getItem("user-token"),
                              },
                            }
                          )
                          .then((response) => {
                            this.isLoading = false;

                            if (response.data.isEmptyTank) {
                              //this.id_tank_phase_wine = 0;
                              this.kolicinaVina = 0;
                              this.isEmptyTank = true;
                            } else {
                              if (this.phase_to_select.id !== undefined)
                                this.faza_izabrani_tank =
                                  this.phase_to_select.id;
                              else
                                this.faza_izabrani_tank = this.phase_to_select;

                              this.getAllTankovi();

                              let s_q = 0;
                              if (this.sediment_quantity !== undefined)
                                s_q = Number(this.sediment_quantity);

                              let o_q = 0;
                              if (this.outage_quantity !== undefined)
                                o_q = Number(this.outage_quantity);

                              this.kolicinaVina =
                                Number(this.kolicinaVinaPom) -
                                Number(this.wine_quantity) -
                                s_q -
                                o_q;
                            }

                            serverBus.$emit(
                              "refresh_pressing",
                              this.id_tank_phase_wine
                            );

                            this.clear();
                          })
                          .catch((e) => {
                            this.isLoading = false;

                            let pomError;

                            if (
                              e.response.data.message ===
                              "exception.tank.pressingSediment.toBeEmpty"
                            )
                              if (this.tank_type === "press")
                                pomError =
                                  "Kada se unese Komina ukupna zapremina koja je izašla iz prese mora biti jednaka zapremini koja je bila u presi, ako to nije slučaj označiti da je Presa ispraznjena.";
                              else
                                pomError =
                                  "Kada se unese Komina ukupna zapremina koja je izašla iz tanka mora biti jednaka zapremini koja je bila u tanku, ako to nije slučaj označiti da je Tank ispraznjen.";
                            else pomError = readJSON(e.response.data.message);

                            alert(pomError);
                          });
                      });
                  } else {
                    this.isLoading = false;

                    let pomError;

                    if (
                      e.response.data.message ===
                      "exception.tank.pressingSediment.toBeEmpty"
                    )
                      if (this.tank_type === "press")
                        pomError =
                          "Kada se unese Komina ukupna zapremina koja je izašla iz prese mora biti jednaka zapremini koja je bila u presi, ako to nije slučaj označiti da je Presa ispraznjena.";
                      else
                        pomError =
                          "Kada se unese Komina ukupna zapremina koja je izašla iz tanka mora biti jednaka zapremini koja je bila u tanku, ako to nije slučaj označiti da je Tank ispraznjen.";
                    else pomError = readJSON(e.response.data.message);

                    alert(pomError);
                  }
                }
              });
          } else {
            this.Pretakanje(0, complexObjectSarza);
          }
        // }
      }
    },
    Pretakanje(idPom, complexObjectSarza) {
      var complexObject;

      var pom_jm_dolivanja_select;
      if (this.jm_dolivanja_select === null) pom_jm_dolivanja_select = "0";
      if (typeof this.jm_dolivanja_select === "undefined")
        pom_jm_dolivanja_select = "0";
      else if (this.jm_dolivanja_select.id == null)
        pom_jm_dolivanja_select = this.jm_dolivanja_select;
      else pom_jm_dolivanja_select = this.jm_dolivanja_select.id;

      var pom_jm_outage_select;

      if (this.jm_outage_select === null) pom_jm_outage_select = "0";
      else if (typeof this.jm_outage_select === "undefined")
        pom_jm_outage_select = "0";
      else if (this.jm_outage_select.id == null)
        pom_jm_outage_select = this.jm_outage_select;
      else pom_jm_outage_select = this.jm_outage_select.id;

      var pom_tank_to_select;

      if (this.tank_to_select.id == null)
        pom_tank_to_select = this.tank_to_select;
      else {
        pom_tank_to_select = this.tank_to_select.id;
        this.tank_to_select_name_nova = this.tank_to_select.name;
      }

      var pom_phase_to_select;
      if (typeof this.phase_to_select !== "undefined")
        if (typeof this.phase_to_select.id !== "undefined")
          if (this.phase_to_select.id == null)
            pom_phase_to_select = this.phase_to_select;
          else pom_phase_to_select = this.phase_to_select.id;

      var pom_wine_to_select;

      if (typeof this.wine_to_select !== "undefined")
        if (this.wine_to_select.id == null)
          pom_wine_to_select = this.wine_to_select;
        else pom_wine_to_select = this.wine_to_select.id;

      if (
        Number(this.outage_quantity) === 0 ||
        this.outage_quantity === "" ||
        typeof this.outage_quantity == "undefined"
      )
        if (
          typeof this.wine_to_select !== "undefined" &&
          this.tip_vina_izabrani_tank_pom !== null &&
          typeof this.tip_vina_izabrani_tank_pom !== "undefined" &&
          this.tip_vina_izabrani_tank_pom !== this.tip_vina_tank
        )
          if (
            // this.faza_izabrani_tank !== null &&
            // typeof this.faza_izabrani_tank !== "undefined" &&
            typeof pom_phase_to_select !== "undefined"
          )
            complexObject = {
              tankPhaseWineId: this.id_tank_phase_wine,
              toTankId: pom_tank_to_select,
              toPhaseId: pom_phase_to_select,
              toWineId: pom_wine_to_select,
              decantingDate: this.date + "T" + this.time,
              quantity: Number(this.wine_quantity),
              sediment: this.sediment_quantity,
              // outage: 0,
              quantityUnitOfMeasureId: pom_jm_dolivanja_select,
              sedimentUnitOfMeasureId: this.litar.id,
              // outageUnitOfMeasureId: null,
              description: this.opis,
              tankFromBatchInOperations: complexObjectSarza,
            };
          else
            complexObject = {
              tankPhaseWineId: this.id_tank_phase_wine,
              toTankId: pom_tank_to_select,
              //toPhaseId: pom_phase_to_select,
              toWineId: pom_wine_to_select,
              decantingDate: this.date + "T" + this.time,
              quantity: Number(this.wine_quantity),
              sediment: this.sediment_quantity,
              // outage: 0,
              quantityUnitOfMeasureId: pom_jm_dolivanja_select,
              sedimentUnitOfMeasureId: this.litar.id,
              // outageUnitOfMeasureId: null,
              description: this.opis,
              tankFromBatchInOperations: complexObjectSarza,
            };
        else if (
          // this.faza_izabrani_tank !== null &&
          // typeof this.faza_izabrani_tank !== "undefined" &&
          typeof pom_phase_to_select !== "undefined"
        )
          complexObject = {
            tankPhaseWineId: this.id_tank_phase_wine,
            toTankId: pom_tank_to_select,
            toPhaseId: pom_phase_to_select,
            // toWineId: this.wine_to_select.id,
            decantingDate: this.date + "T" + this.time,
            quantity: Number(this.wine_quantity),
            sediment: this.sediment_quantity,
            // outage: 0,
            quantityUnitOfMeasureId: pom_jm_dolivanja_select,
            sedimentUnitOfMeasureId: this.litar.id,
            // outageUnitOfMeasureId: null,
            description: this.opis,
            tankFromBatchInOperations: complexObjectSarza,
          };
        else
          complexObject = {
            tankPhaseWineId: this.id_tank_phase_wine,
            toTankId: pom_tank_to_select,
            //toPhaseId: pom_phase_to_select,
            // toWineId: this.wine_to_select.id,
            decantingDate: this.date + "T" + this.time,
            quantity: Number(this.wine_quantity),
            sediment: this.sediment_quantity,
            // outage: 0,
            quantityUnitOfMeasureId: pom_jm_dolivanja_select,
            sedimentUnitOfMeasureId: this.litar.id,
            // outageUnitOfMeasureId: null,
            description: this.opis,
            tankFromBatchInOperations: complexObjectSarza,
          };
      else if (
        typeof this.wine_to_select !== "undefined" &&
        this.tip_vina_izabrani_tank_pom !== null &&
        typeof this.tip_vina_izabrani_tank_pom !== "undefined" &&
        this.tip_vina_izabrani_tank_pom !== this.tip_vina_tank
      )
        if (
          // this.faza_izabrani_tank !== null &&
          // typeof this.faza_izabrani_tank !== "undefined" &&
          typeof pom_phase_to_select !== "undefined"
        )
          complexObject = {
            tankPhaseWineId: this.id_tank_phase_wine,
            toTankId: pom_tank_to_select,
            toPhaseId: pom_phase_to_select,
            toWineId: pom_wine_to_select,
            decantingDate: this.date + "T" + this.time,
            quantity: Number(this.wine_quantity),
            sediment: this.sediment_quantity,
            outage: this.outage_quantity,
            quantityUnitOfMeasureId: pom_jm_dolivanja_select,
            sedimentUnitOfMeasureId: this.litar.id,
            outageUnitOfMeasureId: pom_jm_outage_select,
            description: this.opis,
            tankFromBatchInOperations: complexObjectSarza,
          };
        else
          complexObject = {
            tankPhaseWineId: this.id_tank_phase_wine,
            toTankId: pom_tank_to_select,
            //toPhaseId: pom_phase_to_select,
            toWineId: pom_wine_to_select,
            decantingDate: this.date + "T" + this.time,
            quantity: Number(this.wine_quantity),
            sediment: this.sediment_quantity,
            outage: this.outage_quantity,
            quantityUnitOfMeasureId: pom_jm_dolivanja_select,
            sedimentUnitOfMeasureId: this.litar.id,
            outageUnitOfMeasureId: pom_jm_outage_select,
            description: this.opis,
            tankFromBatchInOperations: complexObjectSarza,
          };
      else if (
        // this.faza_izabrani_tank !== null &&
        // typeof this.faza_izabrani_tank !== "undefined" &&
        typeof pom_phase_to_select !== "undefined"
      )
        complexObject = {
          tankPhaseWineId: this.id_tank_phase_wine,
          toTankId: pom_tank_to_select,
          toPhaseId: pom_phase_to_select,
          // toWineId: this.wine_to_select.id,
          decantingDate: this.date + "T" + this.time,
          quantity: Number(this.wine_quantity),
          sediment: this.sediment_quantity,
          outage: this.outage_quantity,
          quantityUnitOfMeasureId: pom_jm_dolivanja_select,
          sedimentUnitOfMeasureId: this.litar.id,
          outageUnitOfMeasureId: pom_jm_outage_select,
          description: this.opis,
          tankFromBatchInOperations: complexObjectSarza,
        };
      else
        complexObject = {
          tankPhaseWineId: this.id_tank_phase_wine,
          toTankId: pom_tank_to_select,
          // toPhaseId: pom_phase_to_select,
          // toWineId: this.wine_to_select.id,
          decantingDate: this.date + "T" + this.time,
          quantity: Number(this.wine_quantity),
          sediment: this.sediment_quantity,
          outage: this.outage_quantity,
          quantityUnitOfMeasureId: pom_jm_dolivanja_select,
          sedimentUnitOfMeasureId: this.litar.id,
          outageUnitOfMeasureId: pom_jm_outage_select,
          description: this.opis,
          tankFromBatchInOperations: complexObjectSarza,
        };

      complexObject.pressing = true;
      complexObject.pressingFraction = this.pressing_fraction;
      complexObject.emptiedPress = this.cvalue;

      let url;

      if (
        typeof pom_phase_to_select !== "undefined" &&
        this.prethodna_faza !== 0 &&
        this.prethodna_faza !== pom_phase_to_select
      ) {
        let pomDateTime = this.date + "T" + this.time;
        let izabranoVreme = Date.parse(pomDateTime);

        if (izabranoVreme > this.datetime_action) {
          if (
            confirm(
              "Da li ste sigurni da želite promenu faze na dan " +
                this.date +
                "?"
            )
          ) {
            if (idPom === 0) {
              url =
                this.globalServiceLocation +
                this.globalPort +
                "/tank_phase_wine/decanting";
              this.$http
                .post(url, complexObject, {
                  headers: {
                    "Content-Type": "application/json",
                    Authorization:
                      "Bearer  " + localStorage.getItem("user-token"),
                  },
                })
                .then((response) => {
                  this.isLoading = false;

                  if (response.data.isEmptyTank) {
                    //this.id_tank_phase_wine = 0;
                    this.kolicinaVina = 0;
                    this.isEmptyTank = true;
                  } else {
                    if (this.phase_to_select.id !== undefined)
                      this.faza_izabrani_tank = this.phase_to_select.id;
                    else this.faza_izabrani_tank = this.phase_to_select;

                    this.getAllTankovi();

                    let s_q = 0;
                    if (this.sediment_quantity !== undefined)
                      s_q = Number(this.sediment_quantity);

                    let o_q = 0;
                    if (this.outage_quantity !== undefined)
                      o_q = Number(this.outage_quantity);

                    this.kolicinaVina =
                      Number(this.kolicinaVinaPom) -
                      Number(this.wine_quantity) -
                      s_q -
                      o_q;
                  }

                  // this.id_tank_phase_wine = response.data.toTankPhaseWineId;

                  serverBus.$emit("refresh_pressing", this.id_tank_phase_wine);

                  this.clear();
                })
                .catch((e) => {
                  if (!e.response) {
                    this.isLoading = false;

                    alert(
                      this.$t("error.message")
                    );
                  } else {
                    if (e.response.status === 401) {
                      this.$refs.frmtoken
                        .osvezavanjeTokena(
                          localStorage.getItem("user-refresh-token")
                        )
                        .then((result) => {
                          // // console.log(result);
                          // // console.log("Novi token - " + localStorage.getItem("user-token"));

                          this.$http
                            .post(url, complexObject, {
                              headers: {
                                "Content-Type": "application/json",
                                Authorization:
                                  "Bearer  " +
                                  localStorage.getItem("user-token"),
                              },
                            })
                            .then((response) => {
                              this.isLoading = false;

                              if (response.data.isEmptyTank) {
                                //this.id_tank_phase_wine = 0;
                                this.kolicinaVina = 0;
                                this.isEmptyTank = true;
                              } else {
                                if (this.phase_to_select.id !== undefined)
                                  this.faza_izabrani_tank =
                                    this.phase_to_select.id;
                                else
                                  this.faza_izabrani_tank =
                                    this.phase_to_select;

                                this.getAllTankovi();

                                let s_q = 0;
                                if (this.sediment_quantity !== undefined)
                                  s_q = Number(this.sediment_quantity);

                                let o_q = 0;
                                if (this.outage_quantity !== undefined)
                                  o_q = Number(this.outage_quantity);

                                this.kolicinaVina =
                                  Number(this.kolicinaVinaPom) -
                                  Number(this.wine_quantity) -
                                  s_q -
                                  o_q;
                              }

                              // this.id_tank_phase_wine = response.data.toTankPhaseWineId;

                              serverBus.$emit(
                                "refresh_pressing",
                                this.id_tank_phase_wine
                              );

                              this.clear();
                            })
                            .catch((e) => {
                              this.isLoading = false;

                              let pomError;

                              if (
                                e.response.data.message ===
                                "exception.tank.pressingSediment.toBeEmpty"
                              )
                                if (this.tank_type === "press")
                                  pomError =
                                    "Kada se unese Komina ukupna zapremina koja je izašla iz prese mora biti jednaka zapremini koja je bila u presi, ako to nije slučaj označiti da je Presa ispraznjena.";
                                else
                                  pomError =
                                    "Kada se unese Komina ukupna zapremina koja je izašla iz tanka mora biti jednaka zapremini koja je bila u tanku, ako to nije slučaj označiti da je Tank ispraznjen.";
                              else pomError = readJSON(e.response.data.message);

                              alert(pomError);
                            });
                        });
                    } else {
                      this.isLoading = false;

                      let pomError;

                      if (
                        e.response.data.message ===
                        "exception.tank.pressingSediment.toBeEmpty"
                      )
                        if (this.tank_type === "press")
                          pomError =
                            "Kada se unese Komina ukupna zapremina koja je izašla iz prese mora biti jednaka zapremini koja je bila u presi, ako to nije slučaj označiti da je Presa ispraznjena.";
                        else
                          pomError =
                            "Kada se unese Komina ukupna zapremina koja je izašla iz tanka mora biti jednaka zapremini koja je bila u tanku, ako to nije slučaj označiti da je Tank ispraznjen.";
                      else pomError = readJSON(e.response.data.message);

                      alert(pomError);
                    }
                  }
                });
            } else {
              url =
                this.globalServiceLocation +
                this.globalPort +
                "/tank_phase_wine/decanting/update/" +
                idPom;

              this.$http
                .put(url, complexObject, {
                  headers: {
                    "Content-Type": "application/json",
                    Authorization:
                      "Bearer  " + localStorage.getItem("user-token"),
                  },
                })
                .then((response) => {
                  this.isLoading = false;

                  if (response.data.isEmptyTank) {
                    //this.id_tank_phase_wine = 0;
                    this.kolicinaVina = 0;
                    this.isEmptyTank = true;
                  } else {
                    this.getAllTankovi();

                    let s_q = 0;
                    if (this.sediment_quantity !== undefined)
                      s_q = Number(this.sediment_quantity);

                    let o_q = 0;
                    if (this.outage_quantity !== undefined)
                      o_q = Number(this.outage_quantity);

                    this.kolicinaVina =
                      Number(this.kolicinaVinaPom) -
                      Number(this.wine_quantity) -
                      s_q -
                      o_q;
                  }

                  serverBus.$emit("refresh_pressing", this.id_tank_phase_wine);

                  this.clear();
                })
                .catch((e) => {
                  // // console.log(e.response);

                  if (!e.response) {
                    this.isLoading = false;

                    alert(
                      this.$t("error.message")
                    );
                  } else {
                    if (e.response.status === 401) {
                      this.$refs.frmtoken
                        .osvezavanjeTokena(
                          localStorage.getItem("user-refresh-token")
                        )
                        .then((result) => {
                          // // console.log(result);
                          // // console.log("Novi token - " + localStorage.getItem("user-token"));

                          this.$http
                            .put(url, complexObject, {
                              headers: {
                                "Content-Type": "application/json",
                                Authorization:
                                  "Bearer  " +
                                  localStorage.getItem("user-token"),
                              },
                            })
                            .then((response) => {
                              this.isLoading = false;

                              if (response.data.isEmptyTank) {
                                //this.id_tank_phase_wine = 0;
                                this.kolicinaVina = 0;
                                this.isEmptyTank = true;
                              } else {
                                this.getAllTankovi();

                                let s_q = 0;
                                if (this.sediment_quantity !== undefined)
                                  s_q = Number(this.sediment_quantity);

                                let o_q = 0;
                                if (this.outage_quantity !== undefined)
                                  o_q = Number(this.outage_quantity);

                                this.kolicinaVina =
                                  Number(this.kolicinaVinaPom) -
                                  Number(this.wine_quantity) -
                                  s_q -
                                  o_q;
                              }

                              serverBus.$emit(
                                "refresh_pressing",
                                this.id_tank_phase_wine
                              );

                              this.clear();
                            })
                            .catch((e) => {
                              this.isLoading = false;

                              let pomError;

                              if (
                                e.response.data.message ===
                                "exception.tank.pressingSediment.toBeEmpty"
                              )
                                if (this.tank_type === "press")
                                  pomError =
                                    "Kada se unese Komina ukupna zapremina koja je izašla iz prese mora biti jednaka zapremini koja je bila u presi, ako to nije slučaj označiti da je Presa ispraznjena.";
                                else
                                  pomError =
                                    "Kada se unese Komina ukupna zapremina koja je izašla iz tanka mora biti jednaka zapremini koja je bila u tanku, ako to nije slučaj označiti da je Tank ispraznjen.";
                              else pomError = readJSON(e.response.data.message);

                              alert(pomError);
                            });
                        });
                    } else {
                      this.isLoading = false;

                      let pomError;

                      if (
                        e.response.data.message ===
                        "exception.tank.pressingSediment.toBeEmpty"
                      )
                        if (this.tank_type === "press")
                          pomError =
                            "Kada se unese Komina ukupna zapremina koja je izašla iz prese mora biti jednaka zapremini koja je bila u presi, ako to nije slučaj označiti da je Presa ispraznjena.";
                        else
                          pomError =
                            "Kada se unese Komina ukupna zapremina koja je izašla iz tanka mora biti jednaka zapremini koja je bila u tanku, ako to nije slučaj označiti da je Tank ispraznjen.";
                      else pomError = readJSON(e.response.data.message);

                      alert(pomError);
                    }
                  }
                });
            }
          } else this.isLoading = false;
        } else {
          if (
            confirm(
              "Da li ste sigurni da želite promenu faze na dan " +
                this.date +
                "?"
            )
          ) {
            if (idPom === 0) {
              url =
                this.globalServiceLocation +
                this.globalPort +
                "/tank_phase_wine/decanting";
              this.$http
                .post(url, complexObject, {
                  headers: {
                    "Content-Type": "application/json",
                    Authorization:
                      "Bearer  " + localStorage.getItem("user-token"),
                  },
                })
                .then((response) => {
                  this.isLoading = false;

                  if (response.data.isEmptyTank) {
                    //this.id_tank_phase_wine = 0;
                    this.kolicinaVina = 0;
                    this.isEmptyTank = true;
                  } else {
                    if (this.phase_to_select.id !== undefined)
                      this.faza_izabrani_tank = this.phase_to_select.id;
                    else this.faza_izabrani_tank = this.phase_to_select;

                    this.getAllTankovi();

                    let s_q = 0;
                    if (this.sediment_quantity !== undefined)
                      s_q = Number(this.sediment_quantity);

                    let o_q = 0;
                    if (this.outage_quantity !== undefined)
                      o_q = Number(this.outage_quantity);

                    this.kolicinaVina =
                      Number(this.kolicinaVinaPom) -
                      Number(this.wine_quantity) -
                      s_q -
                      o_q;
                  }

                  // this.id_tank_phase_wine = response.data.toTankPhaseWineId;

                  serverBus.$emit("refresh_pressing", this.id_tank_phase_wine);

                  this.clear();
                })
                .catch((e) => {
                  // // console.log(e.response);

                  if (!e.response) {
                    this.isLoading = false;

                    alert(
                      this.$t("error.message")
                    );
                  } else {
                    if (e.response.status === 401) {
                      this.$refs.frmtoken
                        .osvezavanjeTokena(
                          localStorage.getItem("user-refresh-token")
                        )
                        .then((result) => {
                          // // console.log(result);
                          // // console.log("Novi token - " + localStorage.getItem("user-token"));

                          this.$http
                            .post(url, complexObject, {
                              headers: {
                                "Content-Type": "application/json",
                                Authorization:
                                  "Bearer  " +
                                  localStorage.getItem("user-token"),
                              },
                            })
                            .then((response) => {
                              this.isLoading = false;

                              if (response.data.isEmptyTank) {
                                //this.id_tank_phase_wine = 0;
                                this.kolicinaVina = 0;
                                this.isEmptyTank = true;
                              } else {
                                if (this.phase_to_select.id !== undefined)
                                  this.faza_izabrani_tank =
                                    this.phase_to_select.id;
                                else
                                  this.faza_izabrani_tank =
                                    this.phase_to_select;

                                this.getAllTankovi();

                                let s_q = 0;
                                if (this.sediment_quantity !== undefined)
                                  s_q = Number(this.sediment_quantity);

                                let o_q = 0;
                                if (this.outage_quantity !== undefined)
                                  o_q = Number(this.outage_quantity);

                                this.kolicinaVina =
                                  Number(this.kolicinaVinaPom) -
                                  Number(this.wine_quantity) -
                                  s_q -
                                  o_q;
                              }

                              // this.id_tank_phase_wine = response.data.toTankPhaseWineId;

                              serverBus.$emit(
                                "refresh_pressing",
                                this.id_tank_phase_wine
                              );

                              this.clear();
                            })
                            .catch((e) => {
                              this.isLoading = false;

                              let pomError;

                              if (
                                e.response.data.message ===
                                "exception.tank.pressingSediment.toBeEmpty"
                              )
                                if (this.tank_type === "press")
                                  pomError =
                                    "Kada se unese Komina ukupna zapremina koja je izašla iz prese mora biti jednaka zapremini koja je bila u presi, ako to nije slučaj označiti da je Presa ispraznjena.";
                                else
                                  pomError =
                                    "Kada se unese Komina ukupna zapremina koja je izašla iz tanka mora biti jednaka zapremini koja je bila u tanku, ako to nije slučaj označiti da je Tank ispraznjen.";
                              else pomError = readJSON(e.response.data.message);

                              alert(pomError);
                            });
                        });
                    } else {
                      this.isLoading = false;

                      let pomError;

                      if (
                        e.response.data.message ===
                        "exception.tank.pressingSediment.toBeEmpty"
                      )
                        if (this.tank_type === "press")
                          pomError =
                            "Kada se unese Komina ukupna zapremina koja je izašla iz prese mora biti jednaka zapremini koja je bila u presi, ako to nije slučaj označiti da je Presa ispraznjena.";
                        else
                          pomError =
                            "Kada se unese Komina ukupna zapremina koja je izašla iz tanka mora biti jednaka zapremini koja je bila u tanku, ako to nije slučaj označiti da je Tank ispraznjen.";
                      else pomError = readJSON(e.response.data.message);

                      alert(pomError);
                    }
                  }
                });
            } else {
              url =
                this.globalServiceLocation +
                this.globalPort +
                "/tank_phase_wine/decanting/update/" +
                idPom;

              this.$http
                .put(url, complexObject, {
                  headers: {
                    "Content-Type": "application/json",
                    Authorization:
                      "Bearer  " + localStorage.getItem("user-token"),
                  },
                })
                .then((response) => {
                  this.isLoading = false;

                  if (response.data.isEmptyTank) {
                    //this.id_tank_phase_wine = 0;
                    this.kolicinaVina = 0;
                    this.isEmptyTank = true;
                  } else {
                    this.getAllTankovi();

                    let s_q = 0;
                    if (this.sediment_quantity !== undefined)
                      s_q = Number(this.sediment_quantity);

                    let o_q = 0;
                    if (this.outage_quantity !== undefined)
                      o_q = Number(this.outage_quantity);

                    this.kolicinaVina =
                      Number(this.kolicinaVinaPom) -
                      Number(this.wine_quantity) -
                      s_q -
                      o_q;
                  }

                  // this.id_tank_phase_wine = response.data.toTankPhaseWineId;

                  serverBus.$emit("refresh_pressing", this.id_tank_phase_wine);

                  this.clear();
                })
                .catch((e) => {
                  // // console.log(e.response);

                  if (!e.response) {
                    this.isLoading = false;
                    alert(
                      this.$t("error.message")
                    );
                  } else {
                    if (e.response.status === 401) {
                      this.$refs.frmtoken
                        .osvezavanjeTokena(
                          localStorage.getItem("user-refresh-token")
                        )
                        .then((result) => {
                          // // console.log(result);
                          // // console.log("Novi token - " + localStorage.getItem("user-token"));

                          this.$http
                            .put(url, complexObject, {
                              headers: {
                                "Content-Type": "application/json",
                                Authorization:
                                  "Bearer  " +
                                  localStorage.getItem("user-token"),
                              },
                            })
                            .then((response) => {
                              this.isLoading = false;

                              if (response.data.isEmptyTank) {
                                //this.id_tank_phase_wine = 0;
                                this.kolicinaVina = 0;
                                this.isEmptyTank = true;
                              } else {
                                this.getAllTankovi();

                                let s_q = 0;
                                if (this.sediment_quantity !== undefined)
                                  s_q = Number(this.sediment_quantity);

                                let o_q = 0;
                                if (this.outage_quantity !== undefined)
                                  o_q = Number(this.outage_quantity);

                                this.kolicinaVina =
                                  Number(this.kolicinaVinaPom) -
                                  Number(this.wine_quantity) -
                                  s_q -
                                  o_q;
                              }

                              // this.id_tank_phase_wine = response.data.toTankPhaseWineId;

                              serverBus.$emit(
                                "refresh_pressing",
                                this.id_tank_phase_wine
                              );

                              this.clear();
                            })
                            .catch((e) => {
                              this.isLoading = false;

                              let pomError;

                              if (
                                e.response.data.message ===
                                "exception.tank.pressingSediment.toBeEmpty"
                              )
                                if (this.tank_type === "press")
                                  pomError =
                                    "Kada se unese Komina ukupna zapremina koja je izašla iz prese mora biti jednaka zapremini koja je bila u presi, ako to nije slučaj označiti da je Presa ispraznjena.";
                                else
                                  pomError =
                                    "Kada se unese Komina ukupna zapremina koja je izašla iz tanka mora biti jednaka zapremini koja je bila u tanku, ako to nije slučaj označiti da je Tank ispraznjen.";
                              else pomError = readJSON(e.response.data.message);

                              alert(pomError);
                            });
                        });
                    } else {
                      this.isLoading = false;

                      let pomError;

                      if (
                        e.response.data.message ===
                        "exception.tank.pressingSediment.toBeEmpty"
                      )
                        if (this.tank_type === "press")
                          pomError =
                            "Kada se unese Komina ukupna zapremina koja je izašla iz prese mora biti jednaka zapremini koja je bila u presi, ako to nije slučaj označiti da je Presa ispraznjena.";
                        else
                          pomError =
                            "Kada se unese Komina ukupna zapremina koja je izašla iz tanka mora biti jednaka zapremini koja je bila u tanku, ako to nije slučaj označiti da je Tank ispraznjen.";
                      else pomError = readJSON(e.response.data.message);

                      alert(pomError);
                    }
                  }
                });
            }
          } else this.isLoading = false;
        }
      } else {
        if (idPom === 0) {
          url =
            this.globalServiceLocation +
            this.globalPort +
            "/tank_phase_wine/decanting";
          this.$http
            .post(url, complexObject, {
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer  " + localStorage.getItem("user-token"),
              },
            })
            .then((response) => {
              this.isLoading = false;

              if (response.data.isEmptyTank) {
                //this.id_tank_phase_wine = 0;
                this.kolicinaVina = 0;
                this.isEmptyTank = true;
              } else {
                if (this.phase_to_select.id !== undefined)
                  this.faza_izabrani_tank = this.phase_to_select.id;
                else this.faza_izabrani_tank = this.phase_to_select;

                this.getAllTankovi();

                let s_q = 0;
                if (this.sediment_quantity !== undefined)
                  s_q = Number(this.sediment_quantity);

                let o_q = 0;
                if (this.outage_quantity !== undefined)
                  o_q = Number(this.outage_quantity);

                this.kolicinaVina =
                  Number(this.kolicinaVinaPom) -
                  Number(this.wine_quantity) -
                  s_q -
                  o_q;
              }
              // this.id_tank_phase_wine = response.data.toTankPhaseWineId;

              serverBus.$emit("refresh_pressing", this.id_tank_phase_wine);

              this.clear();
            })
            .catch((e) => {
              // // console.log(e.response);

              if (!e.response) {
                this.isLoading = false;
                alert(
                  this.$t("error.message")
                );
              } else {
                if (e.response.status === 401) {
                  this.$refs.frmtoken
                    .osvezavanjeTokena(
                      localStorage.getItem("user-refresh-token")
                    )
                    .then((result) => {
                      // // console.log(result);
                      // // console.log("Novi token - " + localStorage.getItem("user-token"));

                      this.$http
                        .post(url, complexObject, {
                          headers: {
                            "Content-Type": "application/json",
                            Authorization:
                              "Bearer  " + localStorage.getItem("user-token"),
                          },
                        })
                        .then((response) => {
                          this.isLoading = false;

                          if (response.data.isEmptyTank) {
                            //this.id_tank_phase_wine = 0;
                            this.kolicinaVina = 0;
                            this.isEmptyTank = true;
                          } else {
                            if (this.phase_to_select.id !== undefined)
                              this.faza_izabrani_tank = this.phase_to_select.id;
                            else this.faza_izabrani_tank = this.phase_to_select;

                            this.getAllTankovi();

                            let s_q = 0;
                            if (this.sediment_quantity !== undefined)
                              s_q = Number(this.sediment_quantity);

                            let o_q = 0;
                            if (this.outage_quantity !== undefined)
                              o_q = Number(this.outage_quantity);

                            this.kolicinaVina =
                              Number(this.kolicinaVinaPom) -
                              Number(this.wine_quantity) -
                              s_q -
                              o_q;
                          }
                          // this.id_tank_phase_wine = response.data.toTankPhaseWineId;

                          serverBus.$emit(
                            "refresh_pressing",
                            this.id_tank_phase_wine
                          );

                          this.clear();
                        })
                        .catch((e) => {
                          this.isLoading = false;

                          let pomError;

                          if (
                            e.response.data.message ===
                            "exception.tank.pressingSediment.toBeEmpty"
                          )
                            if (this.tank_type === "press")
                              pomError =
                                "Kada se unese Komina ukupna zapremina koja je izašla iz prese mora biti jednaka zapremini koja je bila u presi, ako to nije slučaj označiti da je Presa ispraznjena.";
                            else
                              pomError =
                                "Kada se unese Komina ukupna zapremina koja je izašla iz tanka mora biti jednaka zapremini koja je bila u tanku, ako to nije slučaj označiti da je Tank ispraznjen.";
                          else pomError = readJSON(e.response.data.message);

                          alert(pomError);
                        });
                    });
                } else {
                  this.isLoading = false;

                  let pomError;

                  if (
                    e.response.data.message ===
                    "exception.tank.pressingSediment.toBeEmpty"
                  )
                    if (this.tank_type === "press")
                      pomError =
                        "Kada se unese Komina ukupna zapremina koja je izašla iz prese mora biti jednaka zapremini koja je bila u presi, ako to nije slučaj označiti da je Presa ispraznjena.";
                    else
                      pomError =
                        "Kada se unese Komina ukupna zapremina koja je izašla iz tanka mora biti jednaka zapremini koja je bila u tanku, ako to nije slučaj označiti da je Tank ispraznjen.";
                  else pomError = readJSON(e.response.data.message);

                  alert(pomError);
                }
              }
            });
        } else {
          url =
            this.globalServiceLocation +
            this.globalPort +
            "/tank_phase_wine/decanting/update/" +
            idPom;

          this.$http
            .put(url, complexObject, {
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer  " + localStorage.getItem("user-token"),
              },
            })
            .then((response) => {
              this.isLoading = false;

              if (response.data.isEmptyTank) {
                //this.id_tank_phase_wine = 0;
                this.kolicinaVina = 0;
                this.isEmptyTank = true;
              } else {
                this.getAllTankovi();

                let s_q = 0;
                if (this.sediment_quantity !== undefined)
                  s_q = Number(this.sediment_quantity);

                let o_q = 0;
                if (this.outage_quantity !== undefined)
                  o_q = Number(this.outage_quantity);

                this.kolicinaVina =
                  Number(this.kolicinaVinaPom) -
                  Number(this.wine_quantity) -
                  s_q -
                  o_q;
              }

              // this.id_tank_phase_wine = response.data.toTankPhaseWineId;

              serverBus.$emit("refresh_pressing", this.id_tank_phase_wine);

              this.clear();
            })
            .catch((e) => {
              // // console.log(e.response);

              if (!e.response) {
                this.isLoading = false;

                alert(
                  this.$t("error.message")
                );
              } else {
                if (e.response.status === 401) {
                  this.$refs.frmtoken
                    .osvezavanjeTokena(
                      localStorage.getItem("user-refresh-token")
                    )
                    .then((result) => {
                      // // console.log(result);
                      // // console.log("Novi token - " + localStorage.getItem("user-token"));

                      this.$http
                        .put(url, complexObject, {
                          headers: {
                            "Content-Type": "application/json",
                            Authorization:
                              "Bearer  " + localStorage.getItem("user-token"),
                          },
                        })
                        .then((response) => {
                          this.isLoading = false;

                          if (response.data.isEmptyTank) {
                            //this.id_tank_phase_wine = 0;
                            this.kolicinaVina = 0;
                            this.isEmptyTank = true;
                          } else {
                            this.getAllTankovi();

                            let s_q = 0;
                            if (this.sediment_quantity !== undefined)
                              s_q = Number(this.sediment_quantity);

                            let o_q = 0;
                            if (this.outage_quantity !== undefined)
                              o_q = Number(this.outage_quantity);

                            this.kolicinaVina =
                              Number(this.kolicinaVinaPom) -
                              Number(this.wine_quantity) -
                              s_q -
                              o_q;
                          }

                          // this.id_tank_phase_wine = response.data.toTankPhaseWineId;

                          serverBus.$emit(
                            "refresh_pressing",
                            this.id_tank_phase_wine
                          );

                          this.clear();
                        })
                        .catch((e) => {
                          this.isLoading = false;

                          let pomError;

                          if (
                            e.response.data.message ===
                            "exception.tank.pressingSediment.toBeEmpty"
                          )
                            if (this.tank_type === "press")
                              pomError =
                                "Kada se unese Komina ukupna zapremina koja je izašla iz prese mora biti jednaka zapremini koja je bila u presi, ako to nije slučaj označiti da je Presa ispraznjena.";
                            else
                              pomError =
                                "Kada se unese Komina ukupna zapremina koja je izašla iz tanka mora biti jednaka zapremini koja je bila u tanku, ako to nije slučaj označiti da je Tank ispraznjen.";
                          else pomError = readJSON(e.response.data.message);

                          alert(pomError);
                        });
                    });
                } else {
                  this.isLoading = false;

                  let pomError;

                  if (
                    e.response.data.message ===
                    "exception.tank.pressingSediment.toBeEmpty"
                  )
                    if (this.tank_type === "press")
                      pomError =
                        "Kada se unese Komina ukupna zapremina koja je izašla iz prese mora biti jednaka zapremini koja je bila u presi, ako to nije slučaj označiti da je Presa ispraznjena.";
                    else
                      pomError =
                        "Kada se unese Komina ukupna zapremina koja je izašla iz tanka mora biti jednaka zapremini koja je bila u tanku, ako to nije slučaj označiti da je Tank ispraznjen.";
                  else pomError = readJSON(e.response.data.message);

                  alert(pomError);
                }
              }
            });
        }
      }
    },
    PreostaloUTanku(idTank) {
      if (
        typeof idTank !== "undefined" &&
        typeof idTank !== "object" &&
        idTank !== 0
      )
        this.$http
          .get(
            this.globalServiceLocation +
              this.globalPort +
              "/tank/" +
              idTank +
              "/free_space",
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer  " + localStorage.getItem("user-token"),
              },
            }
          )
          .then((response) => {
            // // console.log(idTank);
            // // console.log(this.wine_quantity);

            if (
              typeof this.wine_quantity === "undefined" ||
              this.wine_quantity === "undefined"
            ) {
              this.preostalo_izabrani_tank = Number(
                response.data.freeSpaceInTank
              );
            } else
              this.preostalo_izabrani_tank =
                Number(response.data.freeSpaceInTank) +
                Number(this.wine_quantity) +
                Number(this.sediment_quantity) +
                Number(this.outage_quantity);

            // alert(this.preostalo_izabrani_tank);

            this.preostalo_izabrani_tank_jm = response.data.unitOfMeasure.mark;

            if (response.data.phase !== null) {
              this.faza_izabrani_tank = response.data.phase.id;
              this.tip_vina_izabrani_tank_pom = response.data.wineId;
            } else {
              this.faza_izabrani_tank = null;
              this.tip_vina_izabrani_tank_pom = null;
            }
          })
          .catch((e) => {
            // // console.log(e.response);

            if (!e.response) {
              alert(
                this.$t("error.message")
              );
            } else {
              if (e.response.status === 401) {
                this.$refs.frmtoken
                  .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                  .then((result) => {
                    // // console.log(result);
                    // // console.log("Novi token - " + localStorage.getItem("user-token"));

                    this.$http
                      .get(
                        this.globalServiceLocation +
                          this.globalPort +
                          "/tank/" +
                          idTank +
                          "/free_space",
                        {
                          headers: {
                            "Content-Type": "application/json",
                            Authorization:
                              "Bearer  " + localStorage.getItem("user-token"),
                          },
                        }
                      )
                      .then((response) => {
                        // // console.log(idTank);
                        // // console.log(this.wine_quantity);

                        if (
                          typeof this.wine_quantity === "undefined" ||
                          this.wine_quantity === "undefined"
                        ) {
                          this.preostalo_izabrani_tank = Number(
                            response.data.freeSpaceInTank
                          );
                        } else
                          this.preostalo_izabrani_tank =
                            Number(response.data.freeSpaceInTank) +
                            Number(this.wine_quantity) +
                            Number(this.sediment_quantity) +
                            Number(this.outage_quantity);

                        // alert(this.preostalo_izabrani_tank);

                        this.preostalo_izabrani_tank_jm =
                          response.data.unitOfMeasure.mark;

                        if (response.data.phase !== null) {
                          this.faza_izabrani_tank = response.data.phase.id;
                          this.tip_vina_izabrani_tank_pom =
                            response.data.wineId;
                        } else {
                          this.faza_izabrani_tank = null;
                          this.tip_vina_izabrani_tank_pom = null;
                        }
                      })
                      .catch((e) => {
                        // // console.log(e.response);

                        let pomError = readJSON(e.response.data.message);
                        pomError = pomError
                          .replace("toTankOld", this.tank_to_select_name_stara)
                          .replace("toTankNew", this.tank_to_select_name_nova)
                          .replace("fromTankOld", "")
                          .replace("fromTank", "");

                        alert(pomError);
                      });
                  });
              } else {
                let pomError = readJSON(e.response.data.message);
                alert(pomError);
              }
            }
          });
    },
    changeRoute(a) {
      if (typeof a !== "undefined") {
        if (a.id === undefined) {
          if (a !== undefined) {
            // this.PreostaloUTanku(a);
            this.wineType(a);
            this.nextPhases(a);
          } else if (typeof this.tank_to_select === "undefined") {
            this.tank_to_select = "undefined";
          }
        } else {
          // if (a.enumLable === "batch") {

          //   this.sarza = true;
          // } else this.sarza = false;

          this.PreostaloUTanku(a.id);
          this.wineType(a.id);
          this.nextPhases(a.id);
        }
      }
    },
    changeSarza(a) {
      if (a !== undefined) {
        this.kolicina_vina_barici = 0;

        if (this.sarza_select.length > 0) {
          if (this.sarza_select !== undefined) {
            this.jm_dolivanja_select = this.sarza_select[0].tank.unitOfMeasure;

            let _this = this;

            this.sarza_select.forEach(function (entry) {
              if (entry.tank.unitOfMeasure.mark === "l")
                _this.kolicina_vina_barici =
                  _this.kolicina_vina_barici + entry.tank.capacity;
              else
                _this.kolicina_vina_barici =
                  _this.kolicina_vina_barici + entry.tank.capacity * 100;
            });
          }

          if (!this.applied) this.wine_quantity = this.kolicina_vina_barici;
          else this.applied = false;
          // } else {
          //   this.jm_dolivanja_select = undefined;
          //   this.wine_quantity = undefined;
        }
      }
    },
    changeSifarnik() {
      if (this.tank_to_select !== undefined) {
        if (
          this.sediment_quantity !== null &&
          this.sediment_quantity !== undefined &&
          this.sediment_quantity !== ""
        )
          this.cvalue = true;
        else this.cvalue = false;

        let pom_phase_to_select;

        let w_q = 0;
        if (this.wine_quantity !== undefined && this.wine_quantity !== null)
          w_q = Number(this.wine_quantity);

        let s_q = 0;
        if (
          this.sediment_quantity !== undefined &&
          this.sediment_quantity !== null
        )
          s_q = Number(this.sediment_quantity);

        let o_q = 0;
        if (this.outage_quantity !== undefined && this.outage_quantity !== null)
          o_q = Number(this.outage_quantity);

        // if (
        //   this.tank_type === "batch" &&
        //   this.kolicina_vina_barici !== w_q + s_q + o_q &&
        //   this.sarza_select.length > 0
        // )
        //   alert(
        //     "Zapremina izabranih barika je različita od ukupne količine vina, taloga i rastura."
        //   );
        // else {
        let wine_quantity = Number(this.wine_quantity);

        var complexObjectSarza = [];

        if (this.tank_type === "batch") {
          let objekat;

          if (this.sarza_select !== undefined) {
            let _this = this;

            this.sarza_select.forEach(function (entry) {
              if (entry.tank !== undefined)
                objekat = {
                  id: entry.id,
                  tank: {
                    id: entry.tank.id,
                  },
                };
              else {
                let ind = _this.izabrani_barici.findIndex(
                  (x) => x.tank.id === entry
                );

                if (ind >= 0) {
                  objekat = {
                    id: _this.izabrani_barici[ind].id,
                    tank: {
                      id: entry,
                    },
                  };
                } else
                  objekat = {
                    tank: {
                      id: entry,
                    },
                  };
              }

              complexObjectSarza.push(objekat);
            });
          }
        }

        if (typeof this.phase_to_select !== "undefined")
          if (typeof this.phase_to_select.id !== "undefined")
            if (this.phase_to_select.id == null)
              pom_phase_to_select = this.phase_to_select;
            else pom_phase_to_select = this.phase_to_select.id;

        // if (this.isEmptyTank) alert("Izabrani tank je prazan");
        // else
        if (Number(wine_quantity) === 0) {
          this.isLoading = false;
          alert("Uneta količina ne sme imati vrednost nula.");
        } else if (
          typeof this.wine_to_select === "undefined" &&
          this.tip_vina_izabrani_tank_pom !== this.tip_vina_tank &&
          this.tip_vina_izabrani_tank_pom !== null &&
          typeof this.tip_vina_izabrani_tank_pom !== "undefined"
        ) {
          this.isLoading = false;
          alert("U tankovima se ne nalazi isto vino, morate navesti novo vino");
        } else if (
          Number(this.tipVina) !== Number(this.tip_vina_izabrani_tank) &&
          this.tip_vina_izabrani_tank !== 0
        ) {
          this.isLoading = false;
          alert(
            "Presovanje nije moguće, u izabranom tanku se nalazi " +
              this.tip_vina_izabrani_tank_naziv +
              " vino."
          );
        } else if (this.id_tank == this.tank_to_select.id) {
          this.isLoading = false;
          alert("Izabrite drugi tank");
        } else if (
          Number(this.sediment_quantity) === 0 ||
          typeof this.sediment_quantity === "undefined" ||
          typeof this.sediment_quantity === ""
        ) {
          var complexObject;
          var pom_jm_dolivanja_select;

          if (this.jm_dolivanja_select === null) pom_jm_dolivanja_select = "0";
          else if (typeof this.jm_dolivanja_select === "undefined")
            pom_jm_dolivanja_select = "0";
          else if (this.jm_dolivanja_select.id == null)
            pom_jm_dolivanja_select = this.jm_dolivanja_select;
          else pom_jm_dolivanja_select = this.jm_dolivanja_select.id;

          var pom_jm_outage_select;

          if (this.jm_outage_select === null) pom_jm_outage_select = "0";
          else if (typeof this.jm_outage_select === "undefined")
            pom_jm_outage_select = "0";
          else if (this.jm_outage_select.id == null)
            pom_jm_outage_select = this.jm_outage_select;
          else pom_jm_outage_select = this.jm_outage_select.id;

          var pom_tank_to_select;

          if (this.tank_to_select.id == null)
            pom_tank_to_select = this.tank_to_select;
          else {
            pom_tank_to_select = this.tank_to_select.id;
            this.tank_to_select_name_nova = this.tank_to_select.name;
          }

          var pom_wine_to_select;
          if (typeof this.wine_to_select !== "undefined")
            if (this.wine_to_select.id == null)
              pom_wine_to_select = this.wine_to_select;
            else pom_wine_to_select = this.wine_to_select.id;

          if (
            Number(this.outage_quantity) === 0 ||
            this.outage_quantity === "" ||
            this.outage_quantity === undefined
          ) {
            if (
              typeof this.wine_to_select !== "undefined" &&
              this.tip_vina_izabrani_tank_pom !== null &&
              typeof this.tip_vina_izabrani_tank_pom !== "undefined" &&
              this.tip_vina_izabrani_tank_pom !== this.tip_vina_tank
            )
              if (
                // this.faza_izabrani_tank !== null &&
                // typeof this.faza_izabrani_tank !== "undefined" &&
                typeof pom_phase_to_select !== "undefined"
              )
                complexObject = {
                  tankPhaseWineId: this.id_tank_phase_wine,
                  toTankId: pom_tank_to_select,
                  toPhaseId: pom_phase_to_select,
                  toWineId: pom_wine_to_select,
                  decantingDate: this.date + "T" + this.time,
                  quantity: Number(this.wine_quantity),
                  // sediment: 0,
                  // outage: 0,
                  quantityUnitOfMeasureId: pom_jm_dolivanja_select,
                  // sedimentUnitOfMeasureId: null,
                  // outageUnitOfMeasureId: null,
                  description: this.opis,
                  tankFromBatchInOperations: complexObjectSarza,
                };
              else
                complexObject = {
                  tankPhaseWineId: this.id_tank_phase_wine,
                  toTankId: pom_tank_to_select,
                  // toPhaseId: pom_phase_to_select,
                  toWineId: pom_wine_to_select,
                  decantingDate: this.date + "T" + this.time,
                  quantity: Number(this.wine_quantity),
                  // sediment: 0,
                  // outage: 0,
                  quantityUnitOfMeasureId: pom_jm_dolivanja_select,
                  // sedimentUnitOfMeasureId: null,
                  // outageUnitOfMeasureId: null,
                  description: this.opis,
                  tankFromBatchInOperations: complexObjectSarza,
                };
            else if (
              // this.faza_izabrani_tank !== null &&
              // typeof this.faza_izabrani_tank !== "undefined" &&
              typeof pom_phase_to_select !== "undefined"
            )
              complexObject = {
                tankPhaseWineId: this.id_tank_phase_wine,
                toTankId: pom_tank_to_select,
                toPhaseId: pom_phase_to_select,
                // toWineId: pom_wine_to_select,
                decantingDate: this.date + "T" + this.time,
                quantity: Number(this.wine_quantity),
                // sediment: 0,
                // outage: 0,
                quantityUnitOfMeasureId: pom_jm_dolivanja_select,
                // sedimentUnitOfMeasureId: null,
                // outageUnitOfMeasureId: null,
                description: this.opis,
                tankFromBatchInOperations: complexObjectSarza,
              };
            else
              complexObject = {
                tankPhaseWineId: this.id_tank_phase_wine,
                toTankId: pom_tank_to_select,
                // toPhaseId: pom_phase_to_select,
                // toWineId: pom_wine_to_select,
                decantingDate: this.date + "T" + this.time,
                quantity: Number(this.wine_quantity),
                // sediment: 0,
                // outage: 0,
                quantityUnitOfMeasureId: pom_jm_dolivanja_select,
                // sedimentUnitOfMeasureId: null,
                // outageUnitOfMeasureId: null,
                description: this.opis,
                tankFromBatchInOperations: complexObjectSarza,
              };
          } else if (
            typeof this.wine_to_select !== "undefined" &&
            this.tip_vina_izabrani_tank_pom !== null &&
            typeof this.tip_vina_izabrani_tank_pom !== "undefined" &&
            this.tip_vina_izabrani_tank_pom !== this.tip_vina_tank
          )
            if (
              // this.faza_izabrani_tank !== null &&
              // typeof this.faza_izabrani_tank !== "undefined" &&
              typeof pom_phase_to_select !== "undefined"
            )
              complexObject = {
                tankPhaseWineId: this.id_tank_phase_wine,
                toTankId: pom_tank_to_select,
                toPhaseId: pom_phase_to_select,
                toWineId: pom_wine_to_select,
                decantingDate: this.date + "T" + this.time,
                quantity: Number(this.wine_quantity),
                // sediment: 0,
                outage: this.outage_quantity,
                quantityUnitOfMeasureId: pom_jm_dolivanja_select,
                // sedimentUnitOfMeasureId: null,
                outageUnitOfMeasureId: pom_jm_outage_select,
                description: this.opis,
                tankFromBatchInOperations: complexObjectSarza,
              };
            else
              complexObject = {
                tankPhaseWineId: this.id_tank_phase_wine,
                toTankId: pom_tank_to_select,
                // toPhaseId: pom_phase_to_select,
                toWineId: pom_wine_to_select,
                decantingDate: this.date + "T" + this.time,
                quantity: Number(this.wine_quantity),
                // sediment: 0,
                outage: this.outage_quantity,
                quantityUnitOfMeasureId: pom_jm_dolivanja_select,
                // sedimentUnitOfMeasureId: null,
                outageUnitOfMeasureId: pom_jm_outage_select,
                description: this.opis,
                tankFromBatchInOperations: complexObjectSarza,
              };
          else if (
            // this.faza_izabrani_tank !== null &&
            // typeof this.faza_izabrani_tank !== "undefined" &&
            typeof pom_phase_to_select !== "undefined"
          )
            complexObject = {
              tankPhaseWineId: this.id_tank_phase_wine,
              toTankId: pom_tank_to_select,
              toPhaseId: pom_phase_to_select,
              // toWineId: pom_wine_to_select,
              decantingDate: this.date + "T" + this.time,
              quantity: Number(this.wine_quantity),
              // sediment: 0,
              outage: this.outage_quantity,
              quantityUnitOfMeasureId: pom_jm_dolivanja_select,
              // sedimentUnitOfMeasureId: null,
              outageUnitOfMeasureId: pom_jm_outage_select,
              description: this.opis,
              tankFromBatchInOperations: complexObjectSarza,
            };
          else
            complexObject = {
              tankPhaseWineId: this.id_tank_phase_wine,
              toTankId: pom_tank_to_select,
              // toPhaseId: pom_phase_to_select,
              // toWineId: pom_wine_to_select,
              decantingDate: this.date + "T" + this.time,
              quantity: Number(this.wine_quantity),
              // sediment: 0,
              outage: this.outage_quantity,
              quantityUnitOfMeasureId: pom_jm_dolivanja_select,
              // sedimentUnitOfMeasureId: null,
              outageUnitOfMeasureId: pom_jm_outage_select,
              description: this.opis,
              tankFromBatchInOperations: complexObjectSarza,
            };

          complexObject.pressing = true;
          complexObject.pressingFraction = this.pressing_fraction;
          complexObject.emptiedPress = this.cvalue;

          if (
            typeof pom_phase_to_select !== "undefined" &&
            this.prethodna_faza !== 0 &&
            this.prethodna_faza !== pom_phase_to_select
          ) {
            let pomDateTime = this.date + "T" + this.time;
            let izabranoVreme = Date.parse(pomDateTime);

            if (izabranoVreme > this.datetime_action) {
              if (
                confirm(
                  "Da li ste sigurni da želite promenu faze na dan " +
                    this.date +
                    "?"
                )
              ) {
                this.$http
                  .put(
                    this.globalServiceLocation +
                      this.globalPort +
                      "/tank_phase_wine/decanting/update/" +
                      this.ID,
                    complexObject,
                    {
                      headers: {
                        "Content-Type": "application/json",
                        Authorization:
                          "Bearer  " + localStorage.getItem("user-token"),
                      },
                    }
                  )
                  .then((response) => {
                    this.isLoading = false;
                    this.clear();

                    if (response.data.isEmptyTank) {
                      // this.id_tank_phase_wine = 0;
                      this.kolicinaVina = 0;
                      this.isEmptyTank = true;
                    } else {
                      this.getAllTankovi();

                      let s_q = 0;
                      if (this.sediment_quantity !== undefined)
                        s_q = Number(this.sediment_quantity);

                      let o_q = 0;
                      if (this.outage_quantity !== undefined)
                        o_q = Number(this.outage_quantity);

                      this.kolicinaVina =
                        Number(this.kolicinaVinaPom) -
                        Number(this.wine_quantity) -
                        s_q -
                        o_q;
                    }
                    // this.id_tank_phase_wine = response.data.toTankPhaseWineId;

                    serverBus.$emit(
                      "refresh_pressing",
                      this.id_tank_phase_wine
                    );
                  })
                  .catch((e) => {
                    // // console.log(e.response);

                    if (!e.response) {
                      this.isLoading = false;

                      alert(
                        this.$t("error.message")
                      );
                    } else {
                      if (e.response.status === 401) {
                        this.$refs.frmtoken
                          .osvezavanjeTokena(
                            localStorage.getItem("user-refresh-token")
                          )
                          .then((result) => {
                            // // console.log(result);
                            // // console.log("Novi token - " + localStorage.getItem("user-token"));

                            this.$http
                              .put(
                                this.globalServiceLocation +
                                  this.globalPort +
                                  "/tank_phase_wine/decanting/update/" +
                                  this.ID,
                                complexObject,
                                {
                                  headers: {
                                    "Content-Type": "application/json",
                                    Authorization:
                                      "Bearer  " +
                                      localStorage.getItem("user-token"),
                                  },
                                }
                              )
                              .then((response) => {
                                this.isLoading = false;
                                this.clear();

                                if (response.data.isEmptyTank) {
                                  // this.id_tank_phase_wine = 0;
                                  this.kolicinaVina = 0;
                                  this.isEmptyTank = true;
                                } else {
                                  this.getAllTankovi();

                                  let s_q = 0;
                                  if (this.sediment_quantity !== undefined)
                                    s_q = Number(this.sediment_quantity);

                                  let o_q = 0;
                                  if (this.outage_quantity !== undefined)
                                    o_q = Number(this.outage_quantity);

                                  this.kolicinaVina =
                                    Number(this.kolicinaVinaPom) -
                                    Number(this.wine_quantity) -
                                    s_q -
                                    o_q;
                                }
                                // this.id_tank_phase_wine = response.data.toTankPhaseWineId;

                                serverBus.$emit(
                                  "refresh_pressing",
                                  this.id_tank_phase_wine
                                );
                              })
                              .catch((e) => {
                                this.isLoading = false;

                                let pomError;

                                if (
                                  e.response.data.message ===
                                  "exception.tank.pressingSediment.toBeEmpty"
                                )
                                  if (this.tank_type === "press")
                                    pomError =
                                      "Kada se unese Komina ukupna zapremina koja je izašla iz prese mora biti jednaka zapremini koja je bila u presi, ako to nije slučaj označiti da je Presa ispraznjena.";
                                  else
                                    pomError =
                                      "Kada se unese Komina ukupna zapremina koja je izašla iz tanka mora biti jednaka zapremini koja je bila u tanku, ako to nije slučaj označiti da je Tank ispraznjen.";
                                else
                                  pomError = readJSON(e.response.data.message);

                                alert(pomError);
                              });
                          });
                      } else {
                        this.isLoading = false;
                        let pomError;

                        if (
                          e.response.data.message ===
                          "exception.tank.pressingSediment.toBeEmpty"
                        )
                          if (this.tank_type === "press")
                            pomError =
                              "Kada se unese Komina ukupna zapremina koja je izašla iz prese mora biti jednaka zapremini koja je bila u presi, ako to nije slučaj označiti da je Presa ispraznjena.";
                          else
                            pomError =
                              "Kada se unese Komina ukupna zapremina koja je izašla iz tanka mora biti jednaka zapremini koja je bila u tanku, ako to nije slučaj označiti da je Tank ispraznjen.";
                        else pomError = readJSON(e.response.data.message);

                        alert(pomError);
                      }
                    }
                  });
              } else this.isLoading = false;
            } else {
              if (
                confirm(
                  "Da li ste sigurni da želite promenu faze na dan " +
                    this.date +
                    "?"
                )
              ) {
                this.$http
                  .put(
                    this.globalServiceLocation +
                      this.globalPort +
                      "/tank_phase_wine/decanting/update/" +
                      this.ID,
                    complexObject,
                    {
                      headers: {
                        "Content-Type": "application/json",
                        Authorization:
                          "Bearer  " + localStorage.getItem("user-token"),
                      },
                    }
                  )
                  .then((response) => {
                    this.isLoading = false;

                    if (response.data.isEmptyTank) {
                      // this.id_tank_phase_wine = 0;
                      this.kolicinaVina = 0;
                      this.isEmptyTank = true;
                    } else {
                      this.getAllTankovi();

                      let s_q = 0;
                      if (this.sediment_quantity !== undefined)
                        s_q = Number(this.sediment_quantity);

                      let o_q = 0;
                      if (this.outage_quantity !== undefined)
                        o_q = Number(this.outage_quantity);

                      this.kolicinaVina =
                        Number(this.kolicinaVinaPom) -
                        Number(this.wine_quantity) -
                        s_q -
                        o_q;
                    }

                    // this.id_tank_phase_wine = response.data.toTankPhaseWineId;

                    serverBus.$emit(
                      "refresh_pressing",
                      this.id_tank_phase_wine
                    );

                    this.clear();
                  })
                  .catch((e) => {
                    // // console.log(e.response);

                    if (!e.response) {
                      this.isLoading = false;
                      alert(
                        this.$t("error.message")
                      );
                    } else {
                      if (e.response.status === 401) {
                        this.$refs.frmtoken
                          .osvezavanjeTokena(
                            localStorage.getItem("user-refresh-token")
                          )
                          .then((result) => {
                            // // console.log(result);
                            // // console.log("Novi token - " + localStorage.getItem("user-token"));

                            this.$http
                              .put(
                                this.globalServiceLocation +
                                  this.globalPort +
                                  "/tank_phase_wine/decanting/update/" +
                                  this.ID,
                                complexObject,
                                {
                                  headers: {
                                    "Content-Type": "application/json",
                                    Authorization:
                                      "Bearer  " +
                                      localStorage.getItem("user-token"),
                                  },
                                }
                              )
                              .then((response) => {
                                this.isLoading = false;

                                if (response.data.isEmptyTank) {
                                  // this.id_tank_phase_wine = 0;
                                  this.kolicinaVina = 0;
                                  this.isEmptyTank = true;
                                } else {
                                  this.getAllTankovi();

                                  let s_q = 0;
                                  if (this.sediment_quantity !== undefined)
                                    s_q = Number(this.sediment_quantity);

                                  let o_q = 0;
                                  if (this.outage_quantity !== undefined)
                                    o_q = Number(this.outage_quantity);

                                  this.kolicinaVina =
                                    Number(this.kolicinaVinaPom) -
                                    Number(this.wine_quantity) -
                                    s_q -
                                    o_q;
                                }

                                // this.id_tank_phase_wine = response.data.toTankPhaseWineId;

                                serverBus.$emit(
                                  "refresh_pressing",
                                  this.id_tank_phase_wine
                                );

                                this.clear();
                              })
                              .catch((e) => {
                                this.isLoading = false;
                                let pomError;

                                if (
                                  e.response.data.message ===
                                  "exception.tank.pressingSediment.toBeEmpty"
                                )
                                  if (this.tank_type === "press")
                                    pomError =
                                      "Kada se unese Komina ukupna zapremina koja je izašla iz prese mora biti jednaka zapremini koja je bila u presi, ako to nije slučaj označiti da je Presa ispraznjena.";
                                  else
                                    pomError =
                                      "Kada se unese Komina ukupna zapremina koja je izašla iz tanka mora biti jednaka zapremini koja je bila u tanku, ako to nije slučaj označiti da je Tank ispraznjen.";
                                else
                                  pomError = readJSON(e.response.data.message);

                                alert(pomError);
                              });
                          });
                      } else {
                        this.isLoading = false;
                        let pomError;

                        if (
                          e.response.data.message ===
                          "exception.tank.pressingSediment.toBeEmpty"
                        )
                          if (this.tank_type === "press")
                            pomError =
                              "Kada se unese Komina ukupna zapremina koja je izašla iz prese mora biti jednaka zapremini koja je bila u presi, ako to nije slučaj označiti da je Presa ispraznjena.";
                          else
                            pomError =
                              "Kada se unese Komina ukupna zapremina koja je izašla iz tanka mora biti jednaka zapremini koja je bila u tanku, ako to nije slučaj označiti da je Tank ispraznjen.";
                        else pomError = readJSON(e.response.data.message);

                        alert(pomError);
                      }
                    }
                  });
              } else this.isLoading = false;
            }
          } else {
            this.$http
              .put(
                this.globalServiceLocation +
                  this.globalPort +
                  "/tank_phase_wine/decanting/update/" +
                  this.ID,
                complexObject,
                {
                  headers: {
                    "Content-Type": "application/json",
                    Authorization:
                      "Bearer  " + localStorage.getItem("user-token"),
                  },
                }
              )
              .then((response) => {
                this.isLoading = false;

                if (response.data.isEmptyTank) {
                  // this.id_tank_phase_wine = 0;
                  this.kolicinaVina = 0;
                  this.isEmptyTank = true;
                } else {
                  this.getAllTankovi();

                  let s_q = 0;
                  if (this.sediment_quantity !== undefined)
                    s_q = Number(this.sediment_quantity);

                  let o_q = 0;
                  if (this.outage_quantity !== undefined)
                    o_q = Number(this.outage_quantity);

                  this.kolicinaVina =
                    Number(this.kolicinaVinaPom) -
                    Number(this.wine_quantity) -
                    s_q -
                    o_q;
                }

                // this.id_tank_phase_wine = response.data.toTankPhaseWineId;

                serverBus.$emit("refresh_pressing", this.id_tank_phase_wine);

                this.clear();
              })
              .catch((e) => {
                // // console.log(e.response);

                if (!e.response) {
                  this.isLoading = false;

                  alert(
                    this.$t("error.message")
                  );
                } else {
                  if (e.response.status === 401) {
                    this.$refs.frmtoken
                      .osvezavanjeTokena(
                        localStorage.getItem("user-refresh-token")
                      )
                      .then((result) => {
                        // // console.log(result);
                        // // console.log("Novi token - " + localStorage.getItem("user-token"));

                        this.$http
                          .put(
                            this.globalServiceLocation +
                              this.globalPort +
                              "/tank_phase_wine/decanting/update/" +
                              this.ID,
                            complexObject,
                            {
                              headers: {
                                "Content-Type": "application/json",
                                Authorization:
                                  "Bearer  " +
                                  localStorage.getItem("user-token"),
                              },
                            }
                          )
                          .then((response) => {
                            this.isLoading = false;

                            if (response.data.isEmptyTank) {
                              // this.id_tank_phase_wine = 0;
                              this.kolicinaVina = 0;
                              this.isEmptyTank = true;
                            } else {
                              this.getAllTankovi();

                              let s_q = 0;
                              if (this.sediment_quantity !== undefined)
                                s_q = Number(this.sediment_quantity);

                              let o_q = 0;
                              if (this.outage_quantity !== undefined)
                                o_q = Number(this.outage_quantity);

                              this.kolicinaVina =
                                Number(this.kolicinaVinaPom) -
                                Number(this.wine_quantity) -
                                s_q -
                                o_q;
                            }

                            // this.id_tank_phase_wine = response.data.toTankPhaseWineId;

                            serverBus.$emit(
                              "refresh_pressing",
                              this.id_tank_phase_wine
                            );

                            this.clear();
                          })
                          .catch((e) => {
                            this.isLoading = false;

                            let pomError = readJSON(e.response.data.message);
                            // pomError = pomError.replace("toTankOld", this.tank_to_select_name_stara).replace("toTankNew", this.tank_to_select_name_nova).replace("fromTankOld", "").replace("fromTank", "");

                            alert(pomError + "$" + this.tank_type);
                          });
                      });
                  } else {
                    this.isLoading = false;
                    let pomError;

                    if (
                      e.response.data.message ===
                      "exception.tank.pressingSediment.toBeEmpty"
                    )
                      if (this.tank_type === "press")
                        pomError =
                          "Kada se unese Komina ukupna zapremina koja je izašla iz prese mora biti jednaka zapremini koja je bila u presi, ako to nije slučaj označiti da je Presa ispraznjena.";
                      else
                        pomError =
                          "Kada se unese Komina ukupna zapremina koja je izašla iz tanka mora biti jednaka zapremini koja je bila u tanku, ako to nije slučaj označiti da je Tank ispraznjen.";
                    else pomError = readJSON(e.response.data.message);

                    alert(pomError);
                  }
                }
              });
          }
        } else {
          // var ukupanIznos =
          //   parseFloat(this.wine_quantity) +
          //   parseFloat(this.sediment_quantity) +
          //   parseFloat(this.outage_quantity);
          // if (parseFloat(this.kolicinaVina) !== ukupanIznos) {
          //   alert(
          //     "Uneli ste talog, a ukupna zbir količine vina koja se pretače, rastura i taloga je različita od količine vina u bačvi."
          //   );
          // } else
          this.Pretakanje(this.ID, complexObjectSarza);
        }
      }
    },
    getAllTankovi() {
      // // console.log(this.id_tank);
      // // console.log(this.tip_vina_tank);
      // // console.log(this.faza);

      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/tank/decanting/" +
            this.id_tank +
            "/" +
            this.tip_vina_tank +
            "/" +
            this.faza_izabrani_tank,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          // // console.log(response.data);

          this.tank_to_items_init = response.data;
          this.tank_to_items_init.splice(0, 0, {
            id: undefined,
            name: undefined,
          });

          // // console.log(this.tank_to_items_init);

          this.tank_to_items = this.tank_to_items_init;

          // // console.log(this.tank_to_items);
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/tank/decanting/" +
                        this.id_tank +
                        "/" +
                        this.tip_vina_tank +
                        "/" +
                        this.faza_izabrani_tank,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      // // console.log(response.data);

                      this.tank_to_items_init = response.data;
                      this.tank_to_items_init.splice(0, 0, {
                        id: undefined,
                        name: undefined,
                      });

                      // // console.log(this.tank_to_items_init);

                      this.tank_to_items = this.tank_to_items_init;

                      // // console.log(this.tank_to_items);
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    getAllFaze() {
      this.$http
        .get(this.globalServiceLocation + this.globalPort + "/phase/all", {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer  " + localStorage.getItem("user-token"),
          },
        })
        .then((response) => {
          //// // console.log(response.data);
          this.phase_to_items = response.data;
          this.phase_to_items.splice(0, 0, { id: undefined, name: undefined });

          // // console.log(this.phase_to_items);
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/phase/all",
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      //// // console.log(response.data);
                      this.phase_to_items = response.data;
                      this.phase_to_items.splice(0, 0, {
                        id: undefined,
                        name: undefined,
                      });

                      // // console.log(this.phase_to_items);
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    getAllVina() {
      this.$http
        .get(this.globalServiceLocation + this.globalPort + "/wine/all", {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer  " + localStorage.getItem("user-token"),
          },
        })
        .then((response) => {
          // // console.log(response.data);

          this.wine_to_items = response.data;
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/wine/all",
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      // // console.log(response.data);

                      this.wine_to_items = response.data;
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    wineType(idTank) {
      if (!isNaN(idTank))
        this.$http
          .get(
            this.globalServiceLocation +
              this.globalPort +
              "/tank_phase_wine/tank/" +
              idTank +
              "/wine_type",
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer  " + localStorage.getItem("user-token"),
              },
            }
          )
          .then((response) => {
            //// // console.log(response.data.id);

            // alert(this.faza_izabrani_tank);

            if (response.data.id !== null) {
              this.tip_vina_izabrani_tank = response.data.id;
              this.tip_vina_izabrani_tank_naziv = response.data.name;

              if (
                this.faza_izabrani_tank === null ||
                this.faza_izabrani_tank === 0
              )
                this.disabled_vine = true;
              else {
                this.disabled_vine = false;

                // if (Number(this.tipVina) === Number(this.tip_vina_izabrani_tank))
                // 	this.disabled_vine = true;
                // else
                // 	this.disabled_vine = false;
              }
            } else {
              this.tip_vina_izabrani_tank = 0;
              this.tip_vina_izabrani_tank_naziv = "";

              this.disabled_vine = true;
            }
          })
          .catch((e) => {
            // // console.log(e.response);

            if (!e.response) {
              alert(
                this.$t("error.message")
              );
            } else {
              if (e.response.status === 401) {
                this.$refs.frmtoken
                  .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                  .then((result) => {
                    // // console.log(result);
                    // // console.log("Novi token - " + localStorage.getItem("user-token"));

                    this.$http
                      .get(
                        this.globalServiceLocation +
                          this.globalPort +
                          "/tank_phase_wine/tank/" +
                          idTank +
                          "/wine_type",
                        {
                          headers: {
                            "Content-Type": "application/json",
                            Authorization:
                              "Bearer  " + localStorage.getItem("user-token"),
                          },
                        }
                      )
                      .then((response) => {
                        //// // console.log(response.data.id);

                        // alert(this.faza_izabrani_tank);

                        if (response.data.id !== null) {
                          this.tip_vina_izabrani_tank = response.data.id;
                          this.tip_vina_izabrani_tank_naziv =
                            response.data.name;

                          if (
                            this.faza_izabrani_tank === null ||
                            this.faza_izabrani_tank === 0
                          )
                            this.disabled_vine = true;
                          else {
                            this.disabled_vine = false;

                            // if (Number(this.tipVina) === Number(this.tip_vina_izabrani_tank))
                            // 	this.disabled_vine = true;
                            // else
                            // 	this.disabled_vine = false;
                          }
                        } else {
                          this.tip_vina_izabrani_tank = 0;
                          this.tip_vina_izabrani_tank_naziv = "";

                          this.disabled_vine = true;
                        }
                      })
                      .catch((e) => {
                        // // console.log(e.response);

                        let pomError = readJSON(e.response.data.message);
                        alert(pomError);
                      });
                  });
              } else {
                let pomError = readJSON(e.response.data.message);
                alert(pomError);
              }
            }
          });
    },
    nextPhases(idTank) {
      if (!isNaN(idTank))
        this.$http
          .get(
            this.globalServiceLocation +
              this.globalPort +
              "/tank_phase_wine/tank/" +
              idTank +
              "/phase_and_wine",
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer  " + localStorage.getItem("user-token"),
              },
            }
          )
          .then((response) => {
            // // console.log(response.data);

            if (response.data.nextPhaseIds !== null) {
              if (response.data.nextPhaseIds.length > 0) {
                this.phase_to_items_pom = this.returnNextPhases(
                  response.data.nextPhaseIds,
                  response.data.phaseId
                );
              } else this.phase_to_items_pom = this.phase_to_items;
            } else this.phase_to_items_pom = this.phase_to_items;

            if (response.data.phaseId !== null)
              this.phase_to_select = response.data.phaseId;
            else if (typeof this.faza !== "undefined")
              this.phase_to_select = Number(this.faza);
            else this.phase_to_select = this.faza_izabranog_tanka;
          })
          .catch((e) => {
            // // console.log(e.response);

            if (!e.response) {
              alert(
                this.$t("error.message")
              );
            } else {
              if (e.response.status === 401) {
                this.$refs.frmtoken
                  .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                  .then((result) => {
                    // // console.log(result);
                    // // console.log("Novi token - " + localStorage.getItem("user-token"));

                    this.$http
                      .get(
                        this.globalServiceLocation +
                          this.globalPort +
                          "/tank_phase_wine/tank/" +
                          idTank +
                          "/phase_and_wine",
                        {
                          headers: {
                            "Content-Type": "application/json",
                            Authorization:
                              "Bearer  " + localStorage.getItem("user-token"),
                          },
                        }
                      )
                      .then((response) => {
                        // // console.log(response.data);

                        if (response.data.nextPhaseIds !== null) {
                          if (response.data.nextPhaseIds.length > 0) {
                            this.phase_to_items_pom = this.returnNextPhases(
                              response.data.nextPhaseIds,
                              response.data.phaseId
                            );
                          } else this.phase_to_items_pom = this.phase_to_items;
                        } else this.phase_to_items_pom = this.phase_to_items;

                        if (response.data.phaseId !== null)
                          this.phase_to_select = response.data.phaseId;
                        else if (typeof this.faza !== "undefined")
                          this.phase_to_select = Number(this.faza);
                        else this.phase_to_select = this.faza_izabranog_tanka;
                      })
                      .catch((e) => {
                        // // console.log(e.response);

                        let pomError = readJSON(e.response.data.message);
                        alert(pomError);
                      });
                  });
              } else {
                let pomError = readJSON(e.response.data.message);
                alert(pomError);
              }
            }
          });
      else this.phase_to_select = "undefined";
    },
    returnNextPhases(locArray, id) {
      var i;
      var obj;
      var pomArray = [];

      obj = this.phase_to_items.findIndex((x) => x.id === id);

      //// // console.log(obj);

      if (typeof obj !== "undefined")
        if (obj > -1) pomArray.push(this.phase_to_items[obj]);

      for (i = 0; i < locArray.length; i++) {
        obj = this.phase_to_items.findIndex((x) => x.id === locArray[i]);

        if (typeof obj !== "undefined") pomArray.push(this.phase_to_items[obj]);
      }

      // // console.log(pomArray);

      return pomArray;
    },
    submit() {
      if (this.$refs.form.validate()) {
        if (this.ID !== "" && Number(this.ID) !== 0) {
          if (this.datum_praznjenja_prese !== null) {
            var d1 = new Date(this.datum_praznjenja_prese);
            var d2 = new Date(this.date + "T" + this.time);

            if (d2 > d1)
              alert(
                "Operacija nije moguća jer je izabrani datum posle datuma pražnjenja prese/tanka."
              );
            else {
              this.isLoading = true;

              setTimeout(() => {
                this.changeSifarnik();
              }, 1000);
            }
          } else {
            this.isLoading = true;

            setTimeout(() => {
              this.changeSifarnik();
            }, 1000);
          }
        } else {
          if (this.datum_praznjenja_prese !== null) {
            var d1 = new Date(this.datum_praznjenja_prese);
            var d2 = new Date(this.date + "T" + this.time);

            if (d2 > d1)
              alert(
                "Operacija nije moguća jer je izabrani datum posle datuma pražnjenja prese/tanka."
              );
            else {
              this.isLoading = true;

              setTimeout(() => {
                this.newSifarnik();
              }, 1000);
            }
          } else {
            this.isLoading = true;

            setTimeout(() => {
              this.newSifarnik();
            }, 1000);
          }
        }
      }
    },
    clear() {
      this.setTime();
      this.setDate();

      this.$refs.form.reset();
      this.$refs.form1.reset();

      if (this.$refs.element1 !== undefined) this.$refs.element1.reset();

      this.$refs.element2.reset();

      this.ID = 0;

      this.disabled_tank = false;
      this.tankId = undefined;

      this.faza = undefined;

      this.izabrani_barici = [];

      this.kolicinaVinaPom = Number(this.kolicinaVina);

      if (this.tank_type === "batch") this.getAllSarze(this.id_tank, null);

      this.$refs.element5.reset();
      this.$refs.element6.reset();
      this.$refs.element7.reset();

      this.jm_dolivanja_select = this.litar;
      this.jm_outage_select = this.litar;

      this.jm_sediment_select = {
        id: 1111,
        mark: "kg",
      };

      this.isLoading = false;
    },
    getAllJediniceMere() {
      let _this = this;

      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/unit_of_measure/group/1",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          let niz = [];

          response.data.forEach(function (entry) {
            if (entry.mark !== "ml") niz.push(entry);

            if (entry.mark === "l") _this.litar = entry;
          });

          this.jm_items = niz;
          this.jm_outage_items = niz;
          // this.jm_sediment_items = niz;

          this.jm_dolivanja_select = this.litar;
          this.jm_outage_select = this.litar;
          this.jm_sediment_select = {
            id: 1111,
            mark: "kg",
          };
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/unit_of_measure/group/1",
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      let niz = [];

                      response.data.forEach(function (entry) {
                        if (entry.mark !== "ml") niz.push(entry);

                        if (entry.mark === "l") _this.litar = entry;
                      });

                      this.jm_items = niz;
                      this.jm_outage_items = niz;
                      // this.jm_sediment_items = niz;

                      this.jm_dolivanja_select = this.litar;
                      this.jm_outage_select = this.litar;
                      this.jm_sediment_select = {
                        id: 1111,
                        mark: "kg",
                      };
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    // sleep(ms) {
    //   return new Promise(resolve => setTimeout(resolve, ms));
    // },
    onCheckboxChange(newValue, oldValue) {
      if (newValue) {
        if (this.wine_quantity === undefined || this.wine_quantity === null) {
          this.wine_quantity = this.kolicinaVina;
          this.sediment_quantity = undefined;
        } else
          this.sediment_quantity =
            Math.round((this.kolicinaVina - this.wine_quantity) * 100) / 100;

        if (Number(this.id_jedinica_mere) !== 0) {
          this.jm_dolivanja_select = Number(this.id_jedinica_mere);
        }
      } else {
        this.wine_quantity = undefined;
        this.sediment_quantity = undefined;
      }
    },
    onKominaChange(e) {
      

      if (e !== null && e !== undefined && e !== "") this.cvalue = true;
      else this.cvalue = false;
    },
  },
  mounted() {
    this.clear();
    // this.setTime();
    // this.setDate();

    //

    this.getAllJediniceMere();
    this.getAllFaze();
    this.getAllVina();

    serverBus.$on("refresh_header", (kolicina, rastur, talog) => {
      this.kolicinaVina =
        Number(this.kolicinaVina) +
        Number(kolicina) +
        Number(rastur) +
        Number(talog);
      this.kolicinaVinaPom = Number(this.kolicinaVina);

      this.clear();
    });

    serverBus.$on("clear_decanting", () => {
      this.clear();
    });

    serverBus.$on("applied_decanting", (item, datum) => {
      this.datum_praznjenja_prese = datum;

      this.applied = true;

      if (item.outage !== null)
        this.kolicinaVinaPom =
          Number(this.kolicinaVina) +
          Number(item.quantity) +
          Number(item.sediment) +
          Number(item.outage.quantity);
      else
        this.kolicinaVinaPom =
          Number(this.kolicinaVina) +
          Number(item.quantity) +
          Number(item.sediment);

      this.ID = item.id;

      this.wine_quantity = item.quantity;

      let addNew = false;

      this.tank_to_items = [];

      for (var i = 0; i < this.tank_to_items_init.length; i++) {
        if (this.tank_to_items_init[i].id === item.tankId) addNew = true;
        this.tank_to_items.push(this.tank_to_items_init[i]);
      }

      if (item.tankFromBatchInOperations.length > 0) {
        let objPom = [];

        if (this.ID !== 0 && item !== null) {
          let _this = this;

          item.tankFromBatchInOperations.forEach(function (entry) {
            objPom.push(entry);

            let pomocniObj;
            pomocniObj = {
              batchPrefix: entry.tank.batchPrefix.split("-")[0],
              batchTank: null,
              id: 777,
              tank: {
                capacity: entry.tank.capacity,
                id: entry.tank.id,
                inventoryNumber: entry.tank.inventoryNumber,
                name: entry.tank.name,
                unitOfMeasure: entry.tank.unitOfMeasure,
              },
              tankNumberInBatch: entry.tank.batchPrefix.split("-")[1],
            };
            _this.sarza_items.push(pomocniObj);
          });

          // this.sarza_items.sort( this.compare );

          this.sarza_select = objPom;
          this.izabrani_barici = objPom;
        }
      } else if (this.ID !== 0 && item !== null) {
        this.sarza_select = [];
        this.izabrani_barici = [];
      }

      if (!addNew) {
        let phaseName = "";

        if (item.phaseName === "Alkoholna fermentacija") phaseName = "AF";
        else if (item.phaseName === "Malolaktička fermentacija")
          phaseName = "MF";
        else if (item.phaseName === "Alkoholna malolaktička fermentacija")
          phaseName = "AM";
        else if (item.phaseName === "Odležavanje") phaseName = "OD";
        else phaseName = "ZA";

        this.tank_to_items.splice(1, 0, {
          id: item.tankId,
          name: item.tankName,
          phaseMark: phaseName,
          tankPhaseWineId: item.tankPhaseWineId,
        });
      }

      this.tank_to_select = item.tankId;
      this.tank_to_select_name_stara = item.tankName;

      this.PreostaloUTanku(item.tankId);
      // this.wineType(item.tankId);
      // this.nextPhases(item.tankId);

      this.jm_dolivanja_select = item.unitOfMeasure;

      this.tip_vina_tank = Number(item.wineId);
      this.wine_to_select = item.wineId;

      this.faza = item.phaseId;

      this.prethodna_faza = item.phaseId;

      this.phase_to_select = Number(item.phaseId);

      this.date = item.date.split("T")[0];
      this.time = this.formatTime(item.date.split("T")[1]);

      this.izmena_praznjenja;

      var d1 = new Date(datum);
      var d2 = new Date(item.date);

      if (d2 >= d1) this.izmena_praznjenja = false;
      else this.izmena_praznjenja = true;

      this.datetime_action = Date.parse(item.thisTankActivePhaseDate);

      this.tekst_labele_1 = "Komina";

      if (item.outage !== null && item.outage !== 0) {
        this.outage_quantity = item.outage.quantity;
        this.jm_outage_select = item.outage.unitOfMeasure;
      } else {
        this.outage_quantity = undefined;
        this.jm_outage_select = this.litar;
      }

      if (item.sediment !== null && item.sediment !== 0) {
        this.sediment_quantity = item.sediment;
      } else {
        this.sediment_quantity = undefined;
      }

      if (item.description === null) this.opis = "";
      else this.opis = item.description;

      this.disabled_tank = true;

      this.cvalue = item.emptiedPress;
      this.pressing_fraction = item.pressingFraction;
    });

    serverBus.$on(
      "pressing",
      (
        id_tank_phase_wine,
        id_tank,
        kolicina_vina,
        faza,
        tip_vina,
        vino_id,
        id_akcije,
        id_jm,
        faza_mark,
        jm_mark,
        tank_type,
        edit
      ) => {
        this.id_tank_phase_wine = Number(id_tank_phase_wine);
        this.id_tank = id_tank;

        this.kolicinaVina = kolicina_vina;
        this.kolicinaVinaPom = this.kolicinaVina;

        this.faza_mark = faza_mark;
        this.jm_mark = jm_mark;

        this.faza_izabranog_tanka = Number(faza);

        this.id_jedinica_mere = id_jm;

        if (typeof edit !== "undefined") this.edit = edit;

        // this.phase_to_select = faza;

        this.tipVina = tip_vina;
        this.tip_vina_tank = Number(vino_id);

        if (Number(tip_vina) !== 0) this.getAllTankovi();

        // if (Number(this.faza) === 1 && Number(this.tipVina) !== 2)
        //   this.tekst_labele_1 = "Komine";
        // else this.tekst_labele_1 = "Taloga";
        this.tekst_labele_1 = "Komina";

        if (tank_type === "press") this.tekst_labele_2 = "Ispražnjena presa";
        else this.tekst_labele_2 = "Ispražnjen tank";

        this.tank_type = tank_type;

        if (tank_type === "batch") this.getAllSarze(id_tank, null);

        if (
          this.jm_outage_select === undefined ||
          this.jm_outage_select === null
        )
          this.jm_outage_select = this.litar;

        if (
          this.jm_sediment_select === undefined ||
          this.jm_sediment_select === null
        )
          this.jm_sediment_select = this.litar;
      }
    );
  },
};
</script>

<style lang="scss" scoped>
.decantingItemComponentForm {
  max-width: 430px;
}

.Description textarea {
  height: 40px;
}

// .v-input.v-text-field {
// 	margin: 0px;
// }

div.v-input.Description.v-textarea.v-text-field {
  margin-top: 0px;
}

div.flex.pa-2 {
  padding-bottom: 0px !important;
  padding-top: 0px !important;
}
</style>
